/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ExaminerRoleEnum {
  AvatarSpeaking = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~AvatarSpeaking',
  EORSpeakingExaminer = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~EOR',
  ESC = 'PFG~IELTS.CMP~Speaking.DM~InCentre.RL~ESC',
  ExaminerTrainer = 'PFG~IELTS.CMP~Speaking.DM~InCentre.RL~ET',
  GELSpeaking = 'PFG~IELTSPreparatory.CMP~Speaking.RL~GEL',
  GELWriting = 'PFG~IELTSPreparatory.CMP~Writing.RL~GEL',
  GlobalVideoCallSpeakingFlexi = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~GlobalVCSFlexi',
  IELTSSpeakingStandard = 'PFG~IELTS.CMP~Speaking.DM~InCentre.RL~Standard',
  IELTSWritingStandard = 'PFG~IELTS.CMP~Writing.RL~Standard',
  IOL = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~IOL',
  Jagged1 = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~Jagged1',
  LifeSkills = 'PFG~IELTS.CMP~Speaking.DM~InCentre.RL~LS',
  LocalVideoCallSpeakingFlexi = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~LocalVCSFlexi',
  LocalVideoCallSpeakingFull = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~LocalVCSFull',
  ModalityA = 'PFG~IELTS.CMP~Speaking.DM~InCentre.RL~ModalityA',
  OnlineMarking = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~OnlineMarking',
  REM = 'PFG~IELTS.CMP~Writing.RL~REM',
  RSS = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~RSS',
  SpeakingESM = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~ESM',
  SpeakingInterlocutor = 'PFG~IELTSPreparatory.CMP~SpeakUp.RL~SI',
  UKVI = 'PFG~IELTS.CMP~Speaking.DM~InCentre.RL~UKVI',
  VCSFullIELTSUKVI = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~GlobalVCSFull',
  VCSLSA1 = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~LSA1',
  VCSLSA2 = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~LSA2',
  VCSLSB1 = 'PFG~IELTS.CMP~Speaking.DM~Online.RL~LSB1',
  WritingESM = 'PFG~IELTS.CMP~Writing.RL~ESM',
}

/** ExaminerType */
export enum ExaminerType {
  IELTS = 1,
  UKVI = 2,
  ET = 3,
  OSM = 4,
  EOR = 5,
  ESC = 6,
}

export enum WritingCertificationTarget {
  WSR1 = 1,
  WSR2 = 2,
  WSR3 = 3,
  WSR4 = 4,
  WSR5 = 5,
  WSR6 = 6,
  WSR7 = 7,
  WSR8 = 8,
  WSR9 = 9,
  WSR10 = 10,
  WSR11 = 11,
  WSR12 = 12,
}

export enum WritingCertificationResultType {
  Pass = 0,
  Band10 = 1,
  Band15 = 2,
  TotalFail = 3,
}

export enum SpeakingMonitoringStage {
  First = 1,
  Second = 2,
  Third = 3,
  Fourth = 4,
  Fifth = 5,
}

export enum SpeakingMonitoringReason {
  PsnMonitoring = 1,
  Eor = 2,
  ThirdMarkedJp = 3,
  FollowUpMonitoring = 4,
  Other = 5,
  PsnRequiredMonitoring = 6,
  PsnAdditionalMonitoring = 7,
}

export enum SpeakingMonitoringResult {
  NotApplicable = 1,
  Standard = 2,
  NonStandardA = 3,
  NonStandardB = 4,
  NonStandardC = 5,
}

export enum SimplifiedNextMonitoringDateState {
  NextTest = 1,
  In3Months = 2,
  Year = 3,
  Blank = 4,
}

export enum SpeakingCertificationTarget {
  SSR1 = 1,
  SSR2 = 2,
  SSR3 = 3,
  SSR4 = 4,
  SSR5 = 5,
  SSR6 = 6,
}

export enum SpeakingCertificationResultType {
  Pass = 0,
  Band10 = 1,
  Band15 = 2,
  TotalFail = 3,
}

export enum Permission {
  FindExaminer = 1,
  ViewNomadsExaminers = 2,
  ViewExaminerDetails = 3,
  EditExaminerDetails = 4,
  ViewExaminerContactDetails = 5,
  EditExaminerContactDetails = 6,
  ViewExaminerStatusesHistory = 7,
  AddNewExaminer = 8,
  UpdateCertificationHistory = 9,
  ViewMonitoringResults = 10,
  UpdateMonitoringResults = 11,
  DeleteAndRestoreMonitoringResults = 12,
  ManageUsers = 13,
  ViewStandardisationHistory = 14,
  UpdateStandardisationHistory = 15,
  EditExaminerCentreRelationships = 16,
  ViewExaminerCentreRelationships = 17,
  SendExaminerCertificationDateToIwas = 18,
  ViewCertificationHistory = 19,
  ViewReport = 20,
  ViewUsers = 21,
  ViewDisciplinary = 22,
  EditDisciplinary = 23,
  UpdateExaminerDocuments = 24,
  ViewExaminerDocuments = 25,
  ViewDashboard = 26,
  CompleteFollowUp = 27,
  DeleteCertificationHistory = 28,
  ViewReportMonitoringDateMigration = 29,
  ViewEorMonitoringResults = 30,
  UpdateEorMonitoringResults = 31,
  ViewEorReport = 32,
  UpdateEorStandardisationHistory = 33,
  CompleteFollowUpMonitoringViews = 34,
  ViewExaminerCommunication = 35,
  ImportTrainings = 36,
  ImportMonitorings = 37,
  ImportExaminerContactDetails = 38,
  ImportExaminerRoles = 39,
  ImportExaminerCentres = 40,
  ImportCertifications = 41,
  ViewExaminerTrainingHistory = 42,
  AddOdp = 43,
  EditOdp = 44,
  DeleteOdp = 45,
  ViewOdp = 46,
  ImportOdpAssessmentAndMonitoring = 47,
  AddCertificationWithPastDate = 48,
  AddCertificationBeforeExisting = 49,
}

export enum OsmMonitoringStatus {
  Current = 0,
  Archived = 1,
  Deleted = 2,
}

export enum OsmMonitoringEvaluationAction {
  Action1 = 1,
  Action2 = 2,
  Action3 = 3,
}

export enum OsmMonitoringResult {
  Phase0 = 1,
  Phase1 = 2,
  Phase2 = 3,
  Phase3 = 4,
  Phase4 = 5,
  Standard = 7,
  NonStandard = 8,
  Active = 10,
  SuspendedForStandards = 11,
  SuspendedForVolume = 12,
}

export enum OsmMonitoringType {
  Osm = 1,
  Eor = 2,
  Rem = 4,
}

export enum OnlineSpeakingMonitoringStatus {
  Current = 0,
  Archived = 1,
  Deleted = 2,
}

export enum OnlineSpeakingMonitoringResult {
  Phase0 = 1,
  Phase1 = 2,
  Phase2 = 3,
  Phase3 = 4,
  Phase4 = 5,
}

export enum OnlineSpeakingMonitoringType {
  ReferenceItems = 1,
}

export enum OdpNextMonitoringDate {
  NextTest = 1,
  In3Months = 2,
  In24Months = 3,
  Blank = 4,
}

export enum OdpMonitoringStage {
  First = 1,
  Second = 2,
  Third = 3,
  Fourth = 4,
  Fifth = 5,
}

export enum OdpMonitoringResult {
  Standard = 1,
  NonStandardA = 2,
  NonStandardB = 3,
}

export enum OdpMonitoringReason {
  NewOrInactive = 1,
  Psn = 2,
  FollowUp = 3,
  TransferredExaminer = 4,
  Other = 5,
}

export enum ReportMonitoringType {
  Speaking = 1,
  Writing = 2,
  LifeSkillsA1 = 3,
  LifeSkillsA2 = 4,
  LifeSkillsB1 = 5,
  Odp = 6,
}

export enum LifeSkillsMonitoringNonStandardReason {
  Ratings = 1,
  Procedures = 2,
  BothRatingAndProcedures = 3,
}

export enum LifeSkillsMonitoringResult {
  Standard = 1,
  NonStandard = 2,
}

export enum LifeSkillsMonitoringStage {
  First = 1,
  Second = 2,
  Third = 3,
  Fourth = 4,
}

export enum MonitoringType {
  Speaking = 1,
  EORSpeaking = 2,
  OSMWriting = 3,
  Writing = 4,
  LifeSkills = 5,
}

export enum ExaminerTrainingHistoryActionType {
  Insert = 1,
  Update = 2,
}

export enum ExaminerTrainingStatus {
  Scheduled = 1,
  Completed = 2,
}

export enum TrainingType {
  Speaking = 1,
  Writing = 2,
  General = 3,
  Other = 4,
}

export enum TrainingCategory {
  Training = 1,
  Standardisation = 2,
  Onboarding = 3,
}

export enum ExaminerDocumentType {
  MonitoringResults = 1,
  CertificationResults = 2,
  InvitationToExamine = 3,
  ExaminerCodeOfPractice = 4,
  ExaminerConfidentialityUndertaking = 5,
  Other = 6,
}

export enum TitleType {
  Dr = 1,
  Ms = 2,
  Miss = 3,
  Mrs = 4,
  Mr = 5,
  Prof = 6,
  PhD = 7,
}

export enum DetailedCertificationType {
  Speaking = 1,
  Writing = 2,
  LifeSkills = 3,
  SpeakingOnline = 4,
}

export enum ExaminerListType {
  General = 0,
  CertificationExpired = 1,
  CertificationExpireSoon = 2,
  MonitoringExpired = 3,
  MonitoringExpireSoon = 4,
  TrainingUpcoming = 5,
  TrainingNotCompleted = 6,
}

export enum CertificationStatusChangeReason {
  ManualChange = 1,
  ExaminerCreated = 2,
  MonitoringCreated = 3,
  MonitoringChanged = 4,
  MonitoringDeleted = 5,
  CertificationExpired = 6,
  CertificationPassed = 7,
  CertificationChanged = 8,
  CertificationDeleted = 9,
  ExaminerInactive = 10,
  DisciplinaryRecord = 11,
  LastTopCertificationsFailed = 12,
  FollowUpCompleted = 13,
  FollowUpDeleted = 14,
  Recalculate = 15,
  StandardisationCreated = 16,
  StandardisationChanged = 17,
}

export enum LifeSkillsLevel {
  A1 = 1,
  A2 = 2,
  B1 = 3,
}

export enum SuspensionReason {
  None = 1,
  ThirdNonStandardInMonitoringGroup = 2,
  ThirdNonStandardInYear = 3,
}

export enum EorMonitoringTypeEnum {
  Q2 = 1,
  Q4 = 2,
  PnsRequests = 3,
  InvestigationRequests = 4,
  Other = 5,
}

export enum EorMonitoringReasonEnum {
  EorMarkersRegularMonitoring = 1,
  Other = 2,
}

export enum EorMonitoringResultEnum {
  Standard = 1,
  NonStandard = 2,
}

export enum EorMonitoringStageEnum {
  First = 1,
  Second = 2,
  Third = 3,
}

export enum WarningType {
  Informal = 1,
  FirstWrittenWarning = 2,
  FinalWrittenWarning = 3,
  GrossMisconduct = 4,
  GrossNegligence = 5,
}

export enum SenderApplication {
  Emm = 1,
}

export enum CertificationTypeEnum {
  Speaking = 1,
  Writing = 2,
  LifeSkills = 3,
}

export enum SortDirection {
  Undefined = 0,
  Asc = 1,
  Desc = 2,
}

export enum CertificationStatus {
  NotYetCertified = 1,
  Expired = 2,
  Suspended = 3,
  New = 4,
  Withdrawn = 5,
  Current = 6,
  Inactive = 7,
  StandardisationDue = 8,
  Standardising = 9,
  Restricted = 10,
}

export enum ReportCertificationType {
  Speaking = 1,
  Writing = 2,
  LifeSkillsA1 = 3,
  LifeSkillsA2 = 4,
  LifeSkillsB1 = 5,
}

export enum CentreTypeSelector {
  BC = 0,
  IDP = 1,
  ALL = 2,
}

export enum ImportStatusEnum {
  Pending = 1,
  Success = 2,
  ParseError = 3,
  Error = 4,
  Timeout = 5,
  InvalidTemplate = 6,
}

export enum SortDirectionCustom {
  Undefined = 0,
  Asc = 1,
  Desc = 2,
}

export enum AuditType {
  SpeakingMonitoring = 1,
  EorSpeakingMonitoring = 2,
}

export interface PagedResultOfAuditHistoryRecord {
  results: AuditHistoryRecord[];
  /** @format int32 */
  count: number;
}

export interface AuditHistoryRecord {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  action: string;
  /** @format date-time */
  createdOn: string;
  createdBy: string;
  data: Record<string, AuditHistoryColumn>;
}

export interface AuditHistoryColumn {
  value: any;
  wasChanged: boolean;
}

export interface ImportFileRecord {
  /** @format int32 */
  importId: number;
  fileName: string;
  status: ImportStatusEnum;
  /** @format int32 */
  successfulRowsCount: number;
  /** @format int32 */
  errorsRowsCount: number;
  /** @format guid */
  errorFileId?: string | null;
  /** @format date-time */
  scheduledTimestamp: string;
  /** @format date-time */
  finishedTimestamp?: string | null;
}

export interface ApiInfo {
  showVersionInfo: boolean;
  environment: string;
  branch: string;
  releaseNumber: string;
  databaseName: string;
  databaseSource: string;
  machineName: string;
}

export interface CentresResponse {
  centres: CentreDto[];
}

export interface CentreDto {
  /** @format int32 */
  id: number;
  name: string;
  centreNumberIdentifier: string;
  isActive: boolean;
  isIdp: boolean;
  /** @format int32 */
  regionId?: number | null;
  /** @format int32 */
  countryId?: number | null;
}

export interface CentresForUserResponse {
  centres: CentreForUserDto[];
}

export interface CentreForUserDto {
  /** @format int32 */
  id: number;
  name: string;
  centreNumberIdentifier: string;
  isActive: boolean;
  disabled: boolean;
}

export interface PagedResultOfCertificationsDueReportResponse {
  results: CertificationsDueReportResponse[];
  /** @format int32 */
  totalCount: number;
}

export interface CertificationsDueReportResponse {
  examinerFirstName: string;
  examinerLastName: string;
  examinerNumber: string;
  /** @format date */
  certificationEndDate?: string | null;
  certificationType: ReportCertificationType;
  certificationStatus: CertificationStatus;
  mainCentreName: string;
}

export interface CertificationStatusLastChangeResponse {
  isSpeakingCertificationChangedManually: boolean;
  isWritingCertificationChangedManually: boolean;
  isOnlineSpeakingStatusChangedManually: boolean;
}

export interface CertificationTypeStatuses {
  certificationType: CertificationTypeEnum;
  certificationStatusShortCodes: CertificationStatus[];
  allowedCertificationStatusTransitions: Record<string, CertificationStatus[]>;
}

export interface CommunicationEmailsResponse {
  emails: CommunicationEmailDto[];
}

export interface CommunicationEmailDto {
  /** @format guid */
  messageGuid: string;
  subject: string;
  application: SenderApplication;
  /** @format date-time */
  date: string;
}

export interface CommunicationEmailResponse {
  email: CommunicationEmailPreviewDto;
}

export interface CommunicationEmailPreviewDto {
  /** @format guid */
  messageGuid: string;
  subject: string;
  category: string;
  messageBody: string;
  /** @format date-time */
  date: string;
}

export interface ResendEmailRequest {
  /** @format guid */
  messageGuid: string;
}

export type Country = ExternalDomainModel & {
  /** @format int32 */
  id: number;
  /** @format int32 */
  countryDomainId: number;
  name: string;
  /** @format int32 */
  sortOrder: number;
  /** @format int32 */
  regionId?: number | null;
  active: boolean;
  isoCode: string;
};

export type ExternalDomainModel = object;

export interface DashboardResponse {
  /** @format int32 */
  speakingExpiredCertificationsCount: number;
  /** @format int32 */
  speakingExpireSoonCertificationsCount: number;
  /** @format int32 */
  speakingExpiredMonitoringsCount: number;
  /** @format int32 */
  speakingExpireSoonMonitoringsCount: number;
  /** @format int32 */
  speakingTrainingUpcomingCount: number;
  /** @format int32 */
  speakingTrainingNotCompletedCount: number;
  /** @format int32 */
  writingExpiredCertificationsCount: number;
  /** @format int32 */
  writingExpireSoonCertificationsCount: number;
  /** @format int32 */
  writingTrainingUpcomingCount: number;
  /** @format int32 */
  writingTrainingNotCompletedCount: number;
  /** @format int32 */
  lifeSkillsExpiredCertificationsCount: number;
  /** @format int32 */
  lifeSkillsExpireSoonCertificationsCount: number;
  /** @format int32 */
  lifeSkillsExpiredMonitoringsCount: number;
  /** @format int32 */
  lifeSkillsExpireSoonMonitoringsCount: number;
  /** @format int32 */
  onlineSpeakingExpiredMonitoringsCount: number;
  /** @format int32 */
  onlineSpeakingExpireSoonMonitoringsCount: number;
}

export interface PagedResultOfDisciplinaryActionDueReportRecordDto {
  results: DisciplinaryActionDueReportRecordDto[];
  /** @format int32 */
  totalCount: number;
}

export interface DisciplinaryActionDueReportRecordDto {
  examinerFirstName: string;
  examinerLastName: string;
  examinerNumber: string;
  /** @format date */
  reviewDate?: string | null;
  warningTypeName: string;
  examinerMainSpeakingCentreName: string;
  examinerMainWritingCentreName: string;
  examinerStatuses: ExaminerCertificationStatusesDto;
}

export interface ExaminerCertificationStatusesDto {
  speakingCertificationStatus: CertificationStatus;
  writingCertificationStatus: CertificationStatus;
  a1LifeSkillCertificationStatus: CertificationStatus;
  a2LifeSkillCertificationStatus: CertificationStatus;
  b1LifeSkillCertificationStatus: CertificationStatus;
  onlineSpeakingStatus: CertificationStatus;
  /** @format date */
  nextSpeakingCertificationDate?: string | null;
  /** @format date */
  nextWritingCertificationDate?: string | null;
  /** @format date */
  nextA1LifeSkillsCertificationDate?: string | null;
  /** @format date */
  nextA2LifeSkillsCertificationDate?: string | null;
  /** @format date */
  nextB1LifeSkillsCertificationDate?: string | null;
}

export type PagedAndSortedQueryParametersOfDisciplinaryActionDueReportRequest =
  PaginationAndSortingParameters & {
    filter: DisciplinaryActionDueReportRequest;
  };

export interface DisciplinaryActionDueReportRequest {
  /** @format date */
  from: string;
  /** @format date */
  to: string;
  warningTypes: WarningType[];
  regionsIds: number[];
  countriesIds: number[];
  centresIds: number[];
  idpCentresIds: number[];
  centreType: CentreTypeSelector;
}

export interface PaginationAndSortingParameters {
  pagination: PaginationParameters;
  sorting: SortingParameters;
  isSortingSpecified: boolean;
  isPaginationSpecified: boolean;
}

export interface PaginationParameters {
  /** @format int32 */
  page: number;
  /** @format int32 */
  pageSize: number;
}

export interface SortingParameters {
  sortField: string;
  sortDir: SortDirection;
}

export interface PagedResultOfDisciplinary {
  results: Disciplinary[];
  /** @format int32 */
  totalCount: number;
}

export interface Disciplinary {
  /** @format int32 */
  id: number;
  /** @format date */
  actionDate: string;
  /** @format date */
  reviewDate?: string | null;
  warningType: WarningType;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  isDeleted: boolean;
  /** @format date-time */
  deletedOn?: string | null;
}

export type DisciplinaryQuery = QueryBase & object;

export type QueryBase = object;

export interface SaveDisciplinaryRequest {
  /** @format date */
  actionDate: string;
  warningType: WarningType;
}

export type District = ExternalDomainModel & {
  /** @format int32 */
  id: number;
  /** @format int32 */
  centreDomainId: number;
  name: string;
  code: string;
};

export interface EorMonitoringDetails {
  /** @format int64 */
  id: number;
  /** @format date */
  monitoringDate: string;
  stage?: EorMonitoringStageEnum | null;
  result: EorMonitoringResultEnum;
  comment: string;
}

export type EorMonitoringGroupDetails = MonitoringDetailsBase & {
  reason: EorMonitoringReasonEnum;
  type: EorMonitoringTypeEnum;
  /** @format date */
  typeYear?: string | null;
  /** @format date */
  typeDate?: string | null;
  typeComment: string;
  /** @format int32 */
  followUpId?: number | null;
  monitorings: EorMonitoringDetails[];
};

export type MonitoringDetailsBase = ModelBase & {
  /** @format int64 */
  id: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  /** @format date */
  monitoringDate: string;
  isDeleted: boolean;
  deletedBy: string;
  /** @format date-time */
  deletedOn?: string | null;
  archivedBy: string;
  /** @format date-time */
  archivedOn?: string | null;
};

export type ModelBase = object;

export interface EorSpeakingSuspension {
  willHaveEorRoleAfterChange: boolean;
  doesExaminerHaveEorRole: boolean;
  changeReason?: SuspensionReason | null;
}

export type EorMonitoringNewStageDetails = ModelBase & {
  /** @format int64 */
  monitoringGroupId: number;
  stageDetails: EorMonitoringDetails;
};

export interface PagedResultOfEorSpeakingMonitoringGroup {
  results: EorSpeakingMonitoringGroup[];
  /** @format int32 */
  count: number;
}

export type EorSpeakingMonitoringGroup = ModelBase & {
  /** @format int64 */
  id: number;
  /** @format date */
  monitoringDate: string;
  isDeleted: boolean;
  reason: EorMonitoringReason;
  type: EorMonitoringType;
  /** @format int32 */
  typeYear?: number | null;
  /** @format date */
  typeDate?: string | null;
  typeComment: string;
  /** @format int32 */
  followUpId?: number | null;
  monitorings: EorSpeakingMonitoring[];
};

export type EorMonitoringReason = IdNamePairOfEorMonitoringReasonEnum & object;

export interface IdNamePairOfEorMonitoringReasonEnum {
  id: EorMonitoringReasonEnum;
  name: string;
}

export type EorMonitoringType = IdNamePairOfEorMonitoringTypeEnum & object;

export interface IdNamePairOfEorMonitoringTypeEnum {
  id: EorMonitoringTypeEnum;
  name: string;
}

export type EorSpeakingMonitoring = ModelBase & {
  /** @format int64 */
  id: number;
  /** @format date */
  monitoringDate: string;
  comment: string;
  result: EorMonitoringResult;
  stage: EorMonitoringStage;
};

export type EorMonitoringResult = IdNamePairOfEorMonitoringResultEnum & object;

export interface IdNamePairOfEorMonitoringResultEnum {
  id: EorMonitoringResultEnum;
  name: string;
}

export type EorMonitoringStage = IdNamePairOfEorMonitoringStageEnum & object;

export interface IdNamePairOfEorMonitoringStageEnum {
  id: EorMonitoringStageEnum;
  name: string;
}

export interface PagedResultOfEorSpeakingMonitoringReportResponse {
  results: EorSpeakingMonitoringReportResponse[];
  /** @format int32 */
  totalCount: number;
}

export interface EorSpeakingMonitoringReportResponse {
  /** @format int64 */
  id: number;
  /** @format date */
  monitoringDate: string;
  result: string;
  stage: string;
  reason: string;
  type: string;
  examinerFirstName: string;
  examinerLastName: string;
  examinerNumber: string;
  /** @format int32 */
  year?: number | null;
}

export interface PagedResultOfExaminerCentreHistoryRecord {
  results: ExaminerCentreHistoryRecord[];
  /** @format int32 */
  totalCount: number;
}

export interface ExaminerCentreHistoryRecord {
  /** @format int32 */
  id: number;
  centreName: string;
  centreNumber: string;
  /** @format date-time */
  affiliationStart: string;
  /** @format date-time */
  affiliationEnd?: string | null;
  isMain: boolean;
  isHub: boolean;
  isIdp: boolean;
  editable: boolean;
}

export interface ExaminerCentre {
  /** @format int32 */
  centreId: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  /** @format date-time */
  affiliationStart: string;
  /** @format date-time */
  affiliationEnd?: string | null;
  certificationType: CertificationTypeEnum;
  isMain: boolean;
}

export interface ExaminerCentreAssignment {
  /** @format int32 */
  centreId: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  certificationType: CertificationTypeEnum;
}

export type ExaminerMainCentreAssignment = ExaminerCentreAssignment & {
  isIdp: boolean;
};

export interface ExaminerIdpCentre {
  /** @format int32 */
  idpCentreId: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  /** @format date-time */
  affiliationStart: string;
  /** @format date-time */
  affiliationEnd?: string | null;
  certificationType: CertificationTypeEnum;
  isMain: boolean;
}

export interface NewExaminerIdpCentreAssignment {
  centreName: string;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  certificationType: CertificationTypeEnum;
  /** @format int32 */
  idpCentreId?: number | null;
  isMain: boolean;
  centreNumberIdentifier: string;
}

export interface ExaminerIdpCentreAssignment {
  /** @format int32 */
  idpCentreId: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  certificationType: CertificationTypeEnum;
}

export type Centre = ExternalDomainModel & {
  /** @format int32 */
  id: number;
  name: string;
  centreNumberIdentifier: string;
  email: string;
  certificationEmail: string;
  /** @format int32 */
  hubDomainId?: number | null;
  disabled: boolean;
  isActive: boolean;
  /** @format int32 */
  timeZoneDomainId?: number | null;
};

export interface IdpCentre {
  /** @format int32 */
  id: number;
  name: string;
  centreNumberIdentifier: string;
}

export type MainCentre = Centre & {
  isIdp: boolean;
  editable: boolean;
};

export interface ExaminerCentreOption {
  /** @format int32 */
  id: number;
  name: string;
}

export interface MainCentreAssignmentValidationResult {
  canAddBcCertification: boolean;
  canAddIdpCertification: boolean;
  errorMessage: string;
}

export type ExaminerCertificationStatusWithDates = ExaminerCertificationStatusBase & {
  speakingCertificationStatus: CertificationStatus;
  writingCertificationStatus: CertificationStatus;
  a1LifeSkillCertificationStatus: CertificationStatus;
  a2LifeSkillCertificationStatus: CertificationStatus;
  b1LifeSkillCertificationStatus: CertificationStatus;
  /** @format date */
  nextSpeakingCertificationDate?: string | null;
  /** @format date */
  nextWritingCertificationDate?: string | null;
  /** @format date */
  nextA1LifeSkillsCertificationDate?: string | null;
  /** @format date */
  nextA2LifeSkillsCertificationDate?: string | null;
  /** @format date */
  nextB1LifeSkillsCertificationDate?: string | null;
  onlineSpeakingStatus: CertificationStatus;
};

export type ExaminerCertificationStatusBase = ModelBase & {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
};

export type ExaminerCertificationStatus = ExaminerCertificationStatusBase & {
  speakingCertificationStatus?: CertificationStatus | null;
  writingCertificationStatus?: CertificationStatus | null;
  a1LifeSkillCertificationStatus?: CertificationStatus | null;
  a2LifeSkillCertificationStatus?: CertificationStatus | null;
  b1LifeSkillCertificationStatus?: CertificationStatus | null;
  onlineSpeakingStatus?: CertificationStatus | null;
};

export interface PagedResultOfCertificationStatusHistory {
  results: CertificationStatusHistory[];
  /** @format int32 */
  totalCount: number;
}

export type CertificationStatusHistory = ModelBase & {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  certificationType: CertificationTypeEnum;
  lifeSkillsLevel?: LifeSkillsLevel | null;
  previousCertificationStatus?: CertificationStatus | null;
  newCertificationStatus: CertificationStatus;
  reason: CertificationStatusChangeReason;
  /** @format date-time */
  createdOn: string;
  createdBy: string;
};

export interface OnlineSpeakingStatusHistoryResult {
  /** @format date */
  date: string;
  actionedBy: string;
  statusBefore?: CertificationStatus | null;
  reason: string;
  statusAfter: CertificationStatus;
}

export interface PagedResultOfExaminerDto {
  results: ExaminerDto[];
  /** @format int32 */
  totalCount: number;
}

export interface ExaminerDto {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  id: number;
  firstName: string;
  lastName: string;
  examinerNumber: string;
  nationalityName: string;
  /** @format date */
  dateOfBirth?: string | null;
  writingMainCentreName: string;
  speakingMainCentreName: string;
  lifeSkillsMainCentreName: string;
  certificationStatus: ExaminerCertificationStatusWithDates;
}

export type ExaminerDetails = ModelBase & {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  id?: number | null;
  firstName: string;
  lastName: string;
  /** @format date */
  dateOfBirth?: string | null;
  examinerNumber: string;
  title?: TitleType | null;
  /** @format int32 */
  nationalityId?: number | null;
  /** @format int32 */
  countryOfResidenceId?: number | null;
  nationalityName: string;
  isSharedCentreExaminer: boolean;
  comments: string;
  /** @format int32 */
  examinerSummaryId: number;
  /** @format int32 */
  psnId: number;
  /** @format guid */
  guid: string;
  /** @format date */
  speakingLastExamDate?: string | null;
  /** @format date */
  onlineSpeakingLastExamDate?: string | null;
  writingCentres: ExaminerDetailsCentre[];
  speakingCentres: ExaminerDetailsCentre[];
  lifeSkillsCentres: ExaminerDetailsCentre[];
  isOsmMonitoringAvailable: boolean;
  /** @format int32 */
  timeZoneDomainId?: number | null;
  isEmailAddressSet: boolean;
  assignedRolesIds: string[];
  isAssignedToHubCentre: boolean;
};

export interface ExaminerDetailsCentre {
  /** @format int32 */
  id: number;
  name: string;
  certificationType: CertificationTypeEnum;
  isIdp: boolean;
  isActive: boolean;
  isMain: boolean;
  isUserAvailable: boolean;
}

export interface CreateOrUpdateExaminerDto {
  firstName: string;
  lastName: string;
  examinerNumber?: string | null;
  title?: TitleType | null;
  /** @format int32 */
  nationalityId?: number | null;
  /** @format date */
  dateOfBirth?: string | null;
  /** @format int32 */
  countryOfResidenceId?: number | null;
  /** @format int32 */
  timeZoneDomainId?: number | null;
  comments?: string | null;
  assignedRolesIds: string[];
}

export type ExaminerContactDetails = ModelBase & {
  /** @format int32 */
  id: number;
  mobilePhoneNumber: string;
  emailAddress1: string;
  homeTelephoneNumber1: string;
  homeTelephoneNumber2: string;
  emailAddress2: string;
  address1: ExaminerAddress;
  address2: ExaminerAddress;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
};

export type ExaminerAddress = ModelBase & {
  /** @format int32 */
  id: number;
  city: string;
  /** @format int32 */
  countryId?: number | null;
  /** @format int32 */
  countryDomainId?: number | null;
  streetAddress1: string;
  streetAddress2: string;
  state: string;
  postCode: string;
};

export type Trainer = ModelBase & {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  id: number;
  firstName: string;
  lastName: string;
  centreIds: number[];
  examinerNumber: string;
};

export interface ProductFamilyGroup {
  id: string;
  name: string;
  components: Component[];
}

export interface Component {
  id: string;
  name: string;
  deliveryMethods: DeliveryMethod[];
  roles: Role[];
}

export interface DeliveryMethod {
  id: string;
  name: string;
  roles: Role[];
}

export interface Role {
  id: string;
  name: string;
}

export interface PagedResultOfExaminerDistrictHistoryRecord {
  results: ExaminerDistrictHistoryRecord[];
  /** @format int32 */
  totalCount: number;
}

export interface ExaminerDistrictHistoryRecord {
  /** @format int32 */
  examinerDistrictId: number;
  /** @format int32 */
  districtId: number;
  districtName: string;
  /** @format date-time */
  affiliationStart: string;
  /** @format date-time */
  affiliationEnd?: string | null;
}

export type ExaminerDistrict = ModelBase & {
  /** @format int32 */
  id: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  /** @format int32 */
  districtId: number;
  /** @format date-time */
  affiliationStart: string;
  /** @format date-time */
  affiliationEnd?: string | null;
  certificationType: CertificationTypeEnum;
};

export interface ExaminerDistrictAssignment {
  /** @format int32 */
  districtId: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  certificationType: CertificationTypeEnum;
}

export interface PagedResultOfExaminerDocument {
  results: ExaminerDocument[];
  /** @format int32 */
  totalCount: number;
}

export type ExaminerDocument = ExaminerDocumentBase & {
  /** @format int32 */
  id: number;
  filename: string;
  /** @format int32 */
  fileId: number;
  isInfected: boolean;
};

export type ExaminerDocumentBase = ModelBase & {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  examinerDocumentType: ExaminerDocumentType;
  documentName: string;
  /** @format date-time */
  signOff?: string | null;
};

export interface FileUrl {
  url: string;
  isScanningInProgress: boolean;
}

export type ExaminerOnlineMeetingProviderAccount = OnlineMeetingProviderAccount & {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
};

export type OnlineMeetingProviderAccount = ModelBase & {
  providerLogin: string;
};

export interface PagedResultOfExaminersReportResponse {
  results: ExaminersReportResponse[];
  /** @format int32 */
  totalCount: number;
}

export interface ExaminersReportResponse {
  firstName: string;
  lastName: string;
  examinerNumber: string;
  writingMainCentreNumber: string;
  writingMainCentreName: string;
  speakingMainCentreNumber: string;
  speakingMainCentreName: string;
  lifeSkillsMainCentreName: string;
  certificationStatus: CertificationStatusWithDates;
  timeZoneDomainName: string;
  countryOfResidenceName: string;
}

export interface CertificationStatusWithDates {
  speakingCertificationStatus: CertificationStatus;
  writingCertificationStatus: CertificationStatus;
  a1LifeSkillCertificationStatus: CertificationStatus;
  a2LifeSkillCertificationStatus: CertificationStatus;
  b1LifeSkillCertificationStatus: CertificationStatus;
  onlineSpeakingStatus: CertificationStatus;
  /** @format date */
  nextSpeakingCertificationDate?: string | null;
  /** @format date */
  nextWritingCertificationDate?: string | null;
  /** @format date */
  nextA1LifeSkillsCertificationDate?: string | null;
  /** @format date */
  nextA2LifeSkillsCertificationDate?: string | null;
  /** @format date */
  nextB1LifeSkillsCertificationDate?: string | null;
}

export interface ExaminerTrainingsResponse {
  examinerTrainings: ExaminerTraining[];
}

export type ExaminerTraining = ExaminerTrainingBase & {
  /** @format int32 */
  id: number;
  trainer: Trainer;
  centre: CentreBasicData;
  training: Training;
};

export interface CentreBasicData {
  /** @format int32 */
  id: number;
  name: string;
  centreNumberIdentifier: string;
}

export type Training = ModelBase & {
  /** @format int32 */
  id: number;
  name: string;
  category: TrainingCategory;
  type: TrainingType;
};

export type ExaminerTrainingBase = ModelBase & {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  /** @format int32 */
  trainingId: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  trainerId: number;
  /** @format int32 */
  centreId: number;
  /** @format date */
  date: string;
  status: ExaminerTrainingStatus;
};

export type CreateExaminerTrainingRequest = ExaminerTrainingBase & object;

export type UpdateExaminerTrainingRequest = ExaminerTrainingBase & object;

export interface ExaminerTrainingHistoryResponse {
  records: ExaminerTrainingHistoryDto[];
}

export interface ExaminerTrainingHistoryDto {
  /** @format int64 */
  id: number;
  /** @format date-time */
  actionedOn: string;
  actionedBy: string;
  actionType: ExaminerTrainingHistoryActionType;
  status: ExaminerTrainingStatus;
  /** @format date */
  trainingDate: string;
  type: TrainingType;
  sessionName: string;
  trainerName: string;
  centreName: string;
  category: TrainingCategory;
}

export interface InfectedFile {
  /** @format guid */
  fileId: string;
}

export type FollowUpDetails = ModelBase & {
  /** @format int32 */
  id?: number | null;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  certificationType: CertificationTypeEnum;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  trainerId?: number | null;
  /** @format date */
  followUpDate: string;
  isFromIdp: boolean;
  idpTrainer?: string | null;
  /** @format int64 */
  monitoringId: number;
  monitoringType: MonitoringType;
};

export type LifeSkillsCertificationSet = DictionaryItem & {
  isActive: boolean;
  /** @format int32 */
  validityInMonths: number;
};

export interface DictionaryItem {
  /** @format int32 */
  id: number;
  name: string;
  shortCode: string;
}

export interface PagedResultOfLifeSkillsCertificationInformation {
  results: LifeSkillsCertificationInformation[];
  /** @format int32 */
  count: number;
}

export type LifeSkillsCertificationInformation = LifeSkillsCertification & {
  lifeSkillsCertificationSetName: string;
};

export type LifeSkillsCertification = ModelBase & {
  /** @format int32 */
  id: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  /** @format date */
  dateOfCertification: string;
  lifeSkillsLevel: LifeSkillsLevel;
  /** @format int32 */
  lifeSkillsCertificationSetId: number;
  isPassed: boolean;
  isFromIdp: boolean;
  isDeleted: boolean;
  lifeSkillsMonitorings: LifeSkillsMonitoring[];
};

export type LifeSkillsMonitoring = ModelBase & {
  /** @format int64 */
  id: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  lifeSkillsLevel: LifeSkillsLevel;
  monitoringStage?: LifeSkillsMonitoringStage | null;
  monitoringResult: LifeSkillsMonitoringResult;
  nonStandardReason?: LifeSkillsMonitoringNonStandardReason | null;
  isFromIdp: boolean;
  /** @format date */
  monitoringDate: string;
  /** @format date */
  certificationDate: string;
  isDeleted: boolean;
  /** @format int32 */
  nonStandardProcedurePoints?: number | null;
  /** @format int32 */
  followUpId?: number | null;
};

export type LifeSkillsCertificationQuery = QueryBase & object;

export type LifeSkillsCertificationDetails = LifeSkillsCertification & {
  canDelete: boolean;
};

export interface LifeSkillsRecertificationDate {
  lifeSkillsLevel: LifeSkillsLevel;
  /** @format date */
  nextRecertificationDate: string;
}

export type LifeSkillCertificationBasicDataOfInteger = CertificationBasicDataOfInteger & {
  level: LifeSkillsLevel;
};

export interface CertificationBasicDataOfInteger {
  /** @format int32 */
  id: number;
  /** @format date */
  date: string;
  /** @format int32 */
  validityInMonths: number;
}

export interface PagedResultOfLifeSkillsMonitoring {
  results: LifeSkillsMonitoring[];
  /** @format int32 */
  count: number;
}

export interface LifeSkillsMonitoringDate {
  lifeSkillsLevel: LifeSkillsLevel;
  /** @format date */
  nextMonitoringDate?: string | null;
  nextMonitoringDateLabel: string;
}

export type LifeSkillsMonitoringDetails = MonitoringDetailsBase & {
  monitoringResult: LifeSkillsMonitoringResult;
  lifeSkillsLevel: LifeSkillsLevel;
  nonStandardReason?: LifeSkillsMonitoringNonStandardReason | null;
  /** @format int32 */
  nonStandardProcedurePoints?: number | null;
  /** @format int32 */
  lifeSkillsCertificationId: number;
  monitoringStage?: LifeSkillsMonitoringStage | null;
  isFromIdp: boolean;
  /** @format int32 */
  followUpId?: number | null;
};

export interface DeletedDetails {
  isDeleted: boolean;
  deletedBy: string;
  /** @format date-time */
  deletedOn?: string | null;
}

export interface PagedResultOfMonitoringDueReportResponse {
  results: MonitoringDueReportResponse[];
  /** @format int32 */
  totalCount: number;
}

export interface MonitoringDueReportResponse {
  examinerFirstName: string;
  examinerLastName: string;
  examinerNumber: string;
  examinerStatus?: CertificationStatus | null;
  mainCentreName: string;
  monitoringType: ReportMonitoringType;
  /** @format date */
  monitoringEndDate?: string | null;
  isNextTest: boolean;
}

export interface PagedResultOfOdpAssessmentListResult {
  results: OdpAssessmentListResult[];
  /** @format int32 */
  totalCount: number;
}

export interface OdpAssessmentListResult {
  /**
   * Strongly-typed identifier (underlying type: Int64)
   * @format int64
   * @example 1
   */
  id: number;
  /** @format date */
  date: string;
  completed: boolean;
  isDeleted: boolean;
}

export interface OdpAssessmentDetailsResult {
  /**
   * Strongly-typed identifier (underlying type: Int64)
   * @format int64
   * @example 1
   */
  id: number;
  /** @format date */
  date: string;
  completed: boolean;
  deletedBy?: string | null;
  /** @format date-time */
  deletedOn?: string | null;
  comment?: string | null;
}

export interface Result {
  isFailure: boolean;
  isSuccess: boolean;
  error: Error[];
}

export interface Error {
  code: string;
  message: string;
  metadata: Record<string, any>;
  propertyName: PropertyName;
}

export interface PropertyName {
  value: string;
  /** @format int32 */
  index?: number | null;
}

export interface CreateOdpAssessmentRequest {
  /** @format date */
  date: string;
  completed: boolean;
  comment?: string | null;
}

export interface UpdateOdpAssessmentRequest {
  /** @format date */
  date: string;
  completed: boolean;
  comment?: string | null;
}

export interface PagedResultOfOdpAssessmentReportRecordDto {
  results: OdpAssessmentReportRecordDto[];
  /** @format int32 */
  totalCount: number;
}

export interface OdpAssessmentReportRecordDto {
  firstName: string;
  lastName: string;
  examinerNumber: string;
  /** @format date */
  date: string;
  completed: boolean;
  isDeleted: boolean;
}

export interface OdpMonitoringListResult {
  /**
   * Strongly-typed identifier (underlying type: Int64)
   * @format int64
   * @example 1
   */
  id: number;
  /** @format date */
  date: string;
  reason: OdpMonitoringReason;
  result: OdpMonitoringResult;
  stage: OdpMonitoringStage;
  hasFollowUp: boolean;
  isDeleted: boolean;
}

export interface OdpMonitoringDetailsResult {
  /**
   * Strongly-typed identifier (underlying type: Int64)
   * @format int64
   * @example 1
   */
  id: number;
  /** @format date */
  date: string;
  reason: OdpMonitoringReason;
  result: OdpMonitoringResult;
  stage: OdpMonitoringStage;
  comment?: string | null;
  deletedBy?: string | null;
  /** @format date-time */
  deletedOn?: string | null;
  customNextMonitoringDate?: OdpNextMonitoringDate | null;
  followUp?: FollowUpDetailsResult | null;
}

export interface FollowUpDetailsResult {
  /** @format date */
  date: string;
  idpTrainer?: string | null;
  trainerName?: string | null;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  trainerId?: number | null;
}

export interface CreateOdpMonitoringRequest {
  /** @format date */
  date: string;
  comment?: string | null;
  reason: OdpMonitoringReason;
  result: OdpMonitoringResult;
  stage: OdpMonitoringStage;
  customNextMonitoringDate?: OdpNextMonitoringDate | null;
}

export interface UpdateOdpMonitoringRequest {
  /** @format date */
  date: string;
  comment?: string | null;
  reason: OdpMonitoringReason;
  result: OdpMonitoringResult;
  stage: OdpMonitoringStage;
  customNextMonitoringDate?: OdpNextMonitoringDate | null;
}

export interface NextOdpMonitoringStageResult {
  stage: OdpMonitoringStage;
}

export interface OdpMonitoringNextDateOptionResult {
  id: OdpNextMonitoringDate;
  name: string;
  calculated: boolean;
}

export interface NextOdpMonitoringDateResult {
  text: string;
}

export interface AddOdpMonitoringFollowUpRequest {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  trainerId?: number | null;
  /** @format date */
  date: string;
  idpTrainer?: string | null;
}

export interface UpdateOdpMonitoringFollowUpRequest {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  trainerId?: number | null;
  /** @format date */
  date: string;
  idpTrainer?: string | null;
}

export interface PagedResultOfOdpMonitoringReportRecordDto {
  results: OdpMonitoringReportRecordDto[];
  /** @format int32 */
  totalCount: number;
}

export interface OdpMonitoringReportRecordDto {
  firstName: string;
  lastName: string;
  examinerNumber: string;
  /** @format date */
  monitoringDate: string;
  reason: OdpMonitoringReason;
  result: OdpMonitoringResult;
  stage: OdpMonitoringStage;
  /** @format date */
  followUpDate?: string | null;
  isDeleted: boolean;
}

export interface CreateOnlineSpeakingMonitoringRequest {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  type: OnlineSpeakingMonitoringType;
  result: OnlineSpeakingMonitoringResult;
  /** @format date */
  monitoringDate: string;
  hasFollowUp: boolean;
  comment: string;
}

export interface UpdateOnlineSpeakingMonitoringRequest {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  type: OnlineSpeakingMonitoringType;
  result: OnlineSpeakingMonitoringResult;
  /** @format date */
  monitoringDate: string;
  hasFollowUp: boolean;
  comment: string;
}

export interface ArchiveOnlineSpeakingMonitoringRequest {
  ids: number[];
}

export interface OnlineSpeakingMonitoringsResponse {
  monitorings: OnlineSpeakingMonitoringDto[];
}

export interface OnlineSpeakingMonitoringDto {
  /** @format int64 */
  id: number;
  type: OnlineSpeakingMonitoringType;
  result: OnlineSpeakingMonitoringResult;
  /** @format date */
  monitoringDate: string;
  hasFollowUp: boolean;
  status: OnlineSpeakingMonitoringStatus;
  /** @format date-time */
  createdOn: string;
}

export interface OnlineSpeakingMonitoringDetailsDto {
  /** @format int64 */
  id: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  type: OnlineSpeakingMonitoringType;
  result: OnlineSpeakingMonitoringResult;
  /** @format date */
  monitoringDate: string;
  hasFollowUp: boolean;
  comment: string;
  status: OnlineSpeakingMonitoringStatus;
  deletedBy: string;
  /** @format date-time */
  deletedOn?: string | null;
  /** @format date-time */
  archivedOn?: string | null;
  archivedBy: string;
  /** @format date-time */
  createdOn: string;
}

export interface UpdateOnlineSpeakingMonitoringFollowUpRequest {
  hasFollowUp: boolean;
}

export interface BulkDeleteOnlineSpeakingMonitoringRequest {
  ids: number[];
}

export interface OnlineSpeakingMonitoringAvailableResultsForExistingMonitoringResponse {
  results: OnlineSpeakingMonitoringResult[];
}

export interface OnlineSpeakingMonitoringAvailableResultsForNewMonitoringResponse {
  results: OnlineSpeakingMonitoringResult[];
}

export interface CreateOsmMonitoringRequest {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  type: OsmMonitoringType;
  result: OsmMonitoringResult;
  /** @format date */
  monitoringDate: string;
  hasFollowUp: boolean;
  comment: string;
  evaluations: CreateOsmMonitoringEvaluationDto[];
}

export interface CreateOsmMonitoringEvaluationDto {
  action: OsmMonitoringEvaluationAction;
  responseId: string;
  examinerRating: string;
  esmRating: string;
  recommendedMaterials: string;
}

export interface UpdateOsmMonitoringRequest {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  result: OsmMonitoringResult;
  /** @format date */
  monitoringDate: string;
  hasFollowUp: boolean;
  comment: string;
  evaluationsToAdd: UpdateOsmMonitoringEvaluationToAddDto[];
  evaluationsToUpdate: UpdateOsmMonitoringEvaluationToUpdateDto[];
  evaluationsToDelete: UpdateOsmMonitoringEvaluationToDeleteDto[];
}

export interface UpdateOsmMonitoringEvaluationToAddDto {
  action: OsmMonitoringEvaluationAction;
  responseId: string;
  examinerRating: string;
  esmRating: string;
  recommendedMaterials: string;
}

export interface UpdateOsmMonitoringEvaluationToUpdateDto {
  /** @format int64 */
  id: number;
  action: OsmMonitoringEvaluationAction;
  responseId: string;
  examinerRating: string;
  esmRating: string;
  recommendedMaterials: string;
}

export interface UpdateOsmMonitoringEvaluationToDeleteDto {
  /** @format int64 */
  id: number;
}

export interface ArchiveOsmMonitoringRequest {
  monitoringIds: number[];
}

export interface OsmMonitoringsResponse {
  osmMonitorings: OsmMonitoringDto[];
}

export interface OsmMonitoringDto {
  /** @format int64 */
  id: number;
  type: OsmMonitoringType;
  result: OsmMonitoringResult;
  /** @format int32 */
  totalOfResult: number;
  /** @format date */
  monitoringDate: string;
  hasFollowUp: boolean;
  status: OsmMonitoringStatus;
  /** @format date-time */
  createdOn: string;
}

export interface OsmMonitoringDetailsDto {
  /** @format int64 */
  id: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  type: OsmMonitoringType;
  result: OsmMonitoringResult;
  /** @format int32 */
  totalOfResult: number;
  /** @format date */
  monitoringDate: string;
  hasFollowUp: boolean;
  comment: string;
  status: OsmMonitoringStatus;
  deletedBy: string;
  /** @format date-time */
  deletedOn?: string | null;
  /** @format date-time */
  archivedOn?: string | null;
  archivedBy: string;
  /** @format date-time */
  createdOn: string;
  evaluations: OsmMonitoringEvaluationDto[];
}

export interface OsmMonitoringEvaluationDto {
  /** @format int64 */
  id: number;
  action: OsmMonitoringEvaluationAction;
  responseId: string;
  examinerRating: string;
  esmRating: string;
  recommendedMaterials: string;
}

export interface UpdateOsmMonitoringFollowUpRequest {
  hasFollowUp: boolean;
}

export interface BulkDeleteOsmMonitoringRequest {
  osMonitoringIds: number[];
}

export interface OsmMonitoringAvailableResultsForExistingMonitoringResponse {
  results: OsmMonitoringResult[];
}

export interface GetOsmMonitoringTypesResponse {
  types: OsmMonitoringTypeDto[];
}

export interface OsmMonitoringTypeDto {
  type: OsmMonitoringType;
  availableResults: OsmMonitoringResult[];
}

export interface OsmMonitoringAvailableResultsForTypeResponse {
  results: OsmMonitoringResult[];
}

export interface PagedResultOfOsmWritingMonitoringReportResponse {
  results: OsmWritingMonitoringReportResponse[];
  /** @format int32 */
  totalCount: number;
}

export interface OsmWritingMonitoringReportResponse {
  examinerFirstName: string;
  examinerLastName: string;
  examinerNumber: string;
  type: string;
  result: string;
  stage: string;
  /** @format date */
  monitoringDate: string;
}

export type Region = DictionaryItem & object;

export type Role2 = DictionaryItem & {
  isRegionRequired: boolean;
  isCentreRequired: boolean;
};

export interface SpeakingCertificationDetailsResult {
  /** @format int64 */
  id: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  /** @format date */
  dateOfCertification: string;
  /** @format int32 */
  speakingCertificationSetId: number;
  speakingCertificationSetName: string;
  isPassed: boolean;
  isFromIdp: boolean;
  isFirstAttempt: boolean;
  isPassedAtEtLevel: boolean;
  standardisationExtension: boolean;
  gapExtension: boolean;
  hasSetRates: boolean;
}

export interface PagedResultOfSpeakingCertificationListItemResult {
  results: SpeakingCertificationListItemResult[];
  /** @format int32 */
  count: number;
}

export interface SpeakingCertificationListItemResult {
  /** @format int64 */
  id: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  /** @format date */
  dateOfCertification: string;
  speakingCertificationSetName: string;
  isPassed: boolean;
  isFromIdp: boolean;
  isFirstAttempt: boolean;
  isPassedAtEtLevel: boolean;
}

export type SpeakingCertificationQuery = QueryBase & object;

export interface SpeakingCertificationCalculationResult {
  speakingCertificationRates: SpeakingCertificationRate[];
  isPassed: boolean;
  isPassedAtEtLevel: boolean;
}

export type SpeakingCertificationRate = SpeakingCertificationRateBase & {
  resultType: SpeakingCertificationResultType;
  /** @format decimal */
  average: number;
  isPassed: boolean;
};

export type SpeakingCertificationRateBase = CertificationRateBase & {
  /** @format int32 */
  id: number;
  /** @format int64 */
  speakingCertificationId: number;
  speakingCertificationTarget: SpeakingCertificationTarget;
  /** @format int32 */
  fluencyAndCoherence: number;
  /** @format int32 */
  gramaticalRangeAndAccuracy: number;
  /** @format int32 */
  lexicalResource: number;
  /** @format int32 */
  pronunciation: number;
};

export type CertificationRateBase = ModelBase & object;

export interface SpeakingCertificationCalculation {
  /** @format int32 */
  speakingCertificationSetId: number;
  speakingCertificationRates: SpeakingCertificationRateBase[];
}

export interface SpeakingCertificationCalculationDetails {
  /** @format date */
  dateOfCertification: string;
  isFromIdp: boolean;
  isPassedAtEtLevel: boolean;
  /** @format int32 */
  speakingCertificationSetId: number;
  speakingCertificationRates: SpeakingCertificationRateBase[];
}

export interface CertificationBasicDataResult {
  /** @format int64 */
  id: number;
  /** @format date */
  date: string;
  /** @format int32 */
  validityInMonths: number;
}

export type AvailableSpeakingCertificationSet = SpeakingCertificationSet & {
  disabled: boolean;
  hasSetRates: boolean;
};

export type SpeakingCertificationSet = DictionaryItem & {
  isActive: boolean;
  /** @format int32 */
  validityInMonths: number;
};

export interface MonitoringDate {
  /** @format date */
  calculatedDate?: string | null;
  text: string;
  /** @format date */
  baseDate?: string | null;
}

export interface SpeakingMonitoringNextDateOptions {
  id: SimplifiedNextMonitoringDateState;
  name: string;
  calculated: boolean;
}

export type SpeakingMonitoringDetails = MonitoringDetailsBase & {
  proceduresResult?: SpeakingMonitoringResult | null;
  ratingResult?: SpeakingMonitoringResult | null;
  finalResult: SpeakingMonitoringResult;
  reason?: SpeakingMonitoringReason | null;
  otherReason: string;
  /** @format int64 */
  speakingCertificationId: number;
  /** @format int32 */
  followUpId?: number | null;
  monitoringStage: SpeakingMonitoringStage;
  isFromIdp: boolean;
  customNextMonitoringDate?: SimplifiedNextMonitoringDateState | null;
};

export interface SaveSpeakingMonitoringRequest {
  /** @format int64 */
  id?: number | null;
  /** @format date */
  monitoringDate: string;
  proceduresResult?: SpeakingMonitoringResult | null;
  ratingResult?: SpeakingMonitoringResult | null;
  finalResult?: SpeakingMonitoringResult | null;
  monitoringStage: SpeakingMonitoringStage;
  reason?: SpeakingMonitoringReason | null;
  isFromIdp: boolean;
  otherReason: string;
  customNextMonitoringDate?: SimplifiedNextMonitoringDateState | null;
}

export interface PagedResultOfSpeakingMonitoring {
  results: SpeakingMonitoring[];
  /** @format int32 */
  count: number;
}

export type SpeakingMonitoring = ModelBase & {
  /** @format int64 */
  id: number;
  proceduresResult?: SpeakingMonitoringResult | null;
  ratingResult?: SpeakingMonitoringResult | null;
  finalResult: SpeakingMonitoringResult;
  monitoringStage: SpeakingMonitoringStage;
  isFromIdp: boolean;
  /** @format date */
  monitoringDate: string;
  /** @format date */
  certificationDate: string;
  isDeleted: boolean;
  reason?: SpeakingMonitoringReason | null;
  /** @format int32 */
  followUpId?: number | null;
  customNextMonitoringDate?: SimplifiedNextMonitoringDateState | null;
};

export interface CustomNextMonitoringDateOptions {
  isMonitoringChangingNextMonitoringDate: boolean;
  canEditCustomNextMonitoringDate: boolean;
}

export interface SpeakingMonitoringFollowUpResult {
  /** @format int32 */
  id: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  trainerId?: number | null;
  /** @format date */
  followUpDate: string;
  isFromIdp: boolean;
  idpTrainer: string;
  /** @format int64 */
  monitoringId: number;
}

export interface SaveSpeakingMonitoringFollowUpRequest {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  trainerId?: number | null;
  /** @format date */
  followUpDate: string;
  isFromIdp: boolean;
  idpTrainer?: string | null;
}

export interface SpeakingMonitoringCalculationRequest {
  proceduresResult?: SpeakingMonitoringResult | null;
  ratingResult?: SpeakingMonitoringResult | null;
}

export interface TimeZoneSimple {
  /** @format int32 */
  id: number;
  name: string;
}

export interface PagedResultOfTrainingAndStandardisationReportRecordDto {
  results: TrainingAndStandardisationReportRecordDto[];
  /** @format int32 */
  totalCount: number;
}

export interface TrainingAndStandardisationReportRecordDto {
  category: TrainingCategory;
  examinerFirstName: string;
  examinerLastName: string;
  examinerNumber: string;
  status: ExaminerTrainingStatus;
  /** @format date */
  date: string;
  type: string;
  sessionName: string;
  organisingCentre: string;
  examinerMainSpeakingCentre: string;
  examinerMainWritingCentre: string;
  isStandardisedNotCertified: boolean;
}

export interface PagedResultOfUser {
  results: User[];
  /** @format int32 */
  totalCount: number;
}

export type User = UserBase & {
  /** @format int32 */
  roleId?: number | null;
  roleName: string;
  regions: UserRegion[];
  centres: UserCentre[];
  /** @format date-time */
  lastLoggedIn?: string | null;
  active: boolean;
  lockedOut: boolean;
};

export interface UserRegion {
  /** @format int32 */
  regionId: number;
  regionName: string;
}

export interface UserCentre {
  /** @format int32 */
  centreId: number;
  centreName: string;
}

export type UserBase = ModelBase & {
  /** @format int64 */
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
};

export type UserWithApp = ModelBase & {
  user: UserBase;
  isEmmUser: boolean;
};

export type UserStatistics = ModelBase & {
  emailAddress: string;
  /** @format date-time */
  lastLoggedIn?: string | null;
};

export interface PagedResultOfWritingCertificationListItem {
  results: WritingCertificationListItem[];
  /** @format int32 */
  count: number;
}

export type WritingCertificationListItem = WritingCertification & {
  writingCertificationSetName: string;
};

export type WritingCertification = ModelBase & {
  /** @format int64 */
  id: number;
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  /** @format date */
  dateOfCertification: string;
  isFirstAttempt: boolean;
  isPassed: boolean;
  isPassedAtEtLevel: boolean;
  isFromIdp: boolean;
  /** @format int32 */
  writingCertificationSetId: number;
  standardisationExtension: boolean;
  gapExtension: boolean;
};

export type WritingCertificationQuery = QueryBase & object;

export type WritingCertificationDetails = WritingCertification & {
  writingCertificationSetName: string;
  hasSetRates: boolean;
};

export interface WritingCertificationCalculationResult {
  writingCertificationRates: WritingCertificationRate[];
  isPassed: boolean;
  isPassedAtEtLevel: boolean;
}

export type WritingCertificationRate = WritingCertificationRateBase & {
  /** @format decimal */
  average: number;
  isPassed: boolean;
  resultType: WritingCertificationResultType;
};

export type WritingCertificationRateBase = CertificationRateBase & {
  /** @format int32 */
  taskAndAchievement: number;
  /** @format int32 */
  coherenceAndCohesion: number;
  /** @format int32 */
  lexicalResource: number;
  /** @format int32 */
  grammaticalRangeAndAccuracy: number;
  writingCertificationTarget: WritingCertificationTarget;
  /** @format int64 */
  writingCertificationId: number;
  /** @format int32 */
  id: number;
};

export type WritingCertificationCalculation = ModelBase & {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId: number;
  /** @format int32 */
  writingCertificationSetId: number;
  writingCertificationRates: WritingCertificationRateBase[];
};

export type WritingCertificationCalculationDetails = WritingCertificationCalculation & {
  /** @format date */
  dateOfCertification: string;
  isFromIdp: boolean;
  isPassedAtEtLevel: boolean;
};

export interface CertificationBasicDataOfLong {
  /** @format int64 */
  id: number;
  /** @format date */
  date: string;
  /** @format int32 */
  validityInMonths: number;
}

export type AvailableWritingCertificationSet = WritingCertificationSet & {
  disabled: boolean;
  hasSetRates: boolean;
};

export type WritingCertificationSet = DictionaryItem & {
  isActive: boolean;
  /** @format int32 */
  validityInMonths: number;
};

export interface GetExaminerHistoryPdfReportParams {
  /** @format int32 */
  examinerId?: number;
}

export interface GetParams {
  /** @format int32 */
  page?: number | null;
  /** @format int32 */
  count?: number | null;
  isPagingSpecified?: boolean;
  'filter.auditType'?: AuditType;
  /** @format int64 */
  'filter.domainId'?: number;
  sortField?: string;
  sortDir?: SortDirectionCustom | null;
  isSortingSpecified?: boolean;
}

export interface GetAllCentresParams {
  type?: CentreTypeSelector;
  regionIds?: number[];
  countryIds?: number[];
}

export interface GetCentresForUserParams {
  /** @format int64 */
  userId: number;
}

export interface IsHubCentreParams {
  /** @format int32 */
  centreId?: number;
}

export interface GetCertificationsDueReportParams {
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  'filter.certificationTypes'?: ReportCertificationType[];
  'filter.regions'?: number[];
  'filter.countries'?: number[];
  'filter.centres'?: number[];
  'filter.idpCentres'?: number[];
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetCertificationsDuePdfReportParams {
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  'filter.certificationTypes'?: ReportCertificationType[];
  'filter.regions'?: number[];
  'filter.countries'?: number[];
  'filter.centres'?: number[];
  'filter.idpCentres'?: number[];
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetCertificationsDueExcelReportParams {
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  'filter.certificationTypes'?: ReportCertificationType[];
  'filter.regions'?: number[];
  'filter.countries'?: number[];
  'filter.centres'?: number[];
  'filter.idpCentres'?: number[];
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetCertificationStatusLastChangeParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetEmailsParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetEmailParams {
  /** @format guid */
  messageGuid: string;
}

export interface GetEmailEmlParams {
  /** @format guid */
  messageGuid: string;
}

export interface GetCountriesParams {
  regionIds?: (number | null)[];
}

export interface GetDashboardParams {
  centreIds?: number[];
}

export interface GetDisciplinaryActionDueExcelReportParams {
  /** @format date */
  'filter.from'?: string;
  /** @format date */
  'filter.to'?: string;
  'filter.warningTypes'?: WarningType[];
  'filter.regionsIds'?: number[];
  'filter.countriesIds'?: number[];
  'filter.centresIds'?: number[];
  'filter.idpCentresIds'?: number[];
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetDisciplinaryActionDuePdfReportParams {
  /** @format date */
  'filter.from'?: string;
  /** @format date */
  'filter.to'?: string;
  'filter.warningTypes'?: WarningType[];
  'filter.regionsIds'?: number[];
  'filter.countriesIds'?: number[];
  'filter.centresIds'?: number[];
  'filter.idpCentresIds'?: number[];
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetDisciplinariesParams {
  filter?: DisciplinaryQuery;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
  /** @format int32 */
  examinerId: number;
}

export interface GetDisciplinaryReviewDateParams {
  /** @format int32 */
  examinerId: number;
}

export interface SaveDisciplinaryParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetDistrictsParams {
  /** @format int32 */
  centreId: number;
}

export interface GetExaminerEorSpeakingMonitoringsParams {
  /** @format int32 */
  page?: number | null;
  /** @format int32 */
  count?: number | null;
  isPagingSpecified?: boolean;
  'filter.showDeleted'?: boolean;
  sortField?: string;
  sortDir?: SortDirectionCustom | null;
  isSortingSpecified?: boolean;
  /** @format int32 */
  examinerId: number;
}

export interface GetParams3 {
  /** @format int64 */
  id: number;
}

export interface DeleteParams {
  /** @format int64 */
  id: number;
}

export interface RestoreParams {
  /** @format int64 */
  id: number;
}

export interface GetNextEorSpeakingMonitoringStageParams {
  /** @format int32 */
  monitoringGroupId?: number;
}

export interface GetEorSpeakingMonitoringReportParams {
  'filter.monitoringReason'?: number[];
  'filter.monitoringResult'?: number[];
  'filter.monitoringStage'?: number[];
  'filter.monitoringType'?: number[];
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetEorSpeakingMonitoringPdfReportParams {
  'filter.monitoringReason'?: number[];
  'filter.monitoringResult'?: number[];
  'filter.monitoringStage'?: number[];
  'filter.monitoringType'?: number[];
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetEorSpeakingMonitoringExcelReportParams {
  'filter.monitoringReason'?: number[];
  'filter.monitoringResult'?: number[];
  'filter.monitoringStage'?: number[];
  'filter.monitoringType'?: number[];
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetExaminerCentreListParams {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  'filter.examinerId'?: number;
  'filter.certificationType'?: CertificationTypeEnum;
  'filter.showHistorical'?: boolean;
  'filter.idpOnly'?: boolean;
  'filter.bcOnly'?: boolean;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface CheckIfAssignedToAnyCentreParams {
  /** @format int32 */
  examinerId: number;
  certificationType: CertificationTypeEnum;
}

export interface GetAvailableCentreOptionsParams {
  /** @format int32 */
  examinerId: number;
  certificationType: CertificationTypeEnum;
}

export interface GetIdpCentreSuggestionsParams {
  searchPhrase?: string;
}

export interface GetIdpCentreNumberSuggestionsParams {
  searchPhrase?: string;
}

export interface GetExaminerMainCentreParams {
  /** @format int32 */
  examinerId: number;
  certificationType: CertificationTypeEnum;
}

export interface GetExaminerSharedCentresParams {
  /** @format int32 */
  examinerId: number;
  certificationType: CertificationTypeEnum;
}

export interface GetExaminerIdpSharedCentresParams {
  /** @format int32 */
  examinerId: number;
  certificationType: CertificationTypeEnum;
}

export interface ValidateMainCentreAssignmentForCertificationTypeParams {
  /** @format int32 */
  examinerId: number;
  certificationType: CertificationTypeEnum;
}

export interface GetExaminerStatusParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetExaminerStatusHistoryParams {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  'filter.examinerId'?: number;
  'filter.certificationType'?: CertificationTypeEnum;
  'filter.lifeSkillsLevel'?: LifeSkillsLevel | null;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetOnlineSpeakingStatusHistoryParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetExaminersV2Params {
  'filter.searchText'?: string;
  'filter.speakingStatuses'?: CertificationStatus[];
  'filter.writingStatuses'?: CertificationStatus[];
  'filter.onlineSpeakingStatuses'?: CertificationStatus[];
  'filter.lifeSkillsStatuses'?: CertificationStatus[];
  'filter.centres'?: number[];
  'filter.idpCentres'?: number[];
  'filter.countryIds'?: number[];
  'filter.regionIds'?: number[];
  'filter.firstName'?: string;
  'filter.lastName'?: string;
  'filter.showNomads'?: boolean;
  'filter.listType'?: ExaminerListType | null;
  'filter.detailedCertificationType'?: DetailedCertificationType | null;
  /** @format int32 */
  'filter.countryOfResidenceId'?: number | null;
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetExaminerDetailsParams {
  /** @format int32 */
  examinerId: number;
}

export interface UpdateExaminerParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetExaminerContactDetailsParams {
  /** @format int32 */
  examinerId: number;
}

export interface SaveExaminerContactDetailsParams {
  /** @format int32 */
  examinerId: number;
}

export interface ValidatePostCodeAndGetAddressParams {
  propertyName?: string;
}

export interface GetExaminerDistrictListParams {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  'filter.examinerId'?: number;
  'filter.certificationType'?: CertificationTypeEnum;
  'filter.showHistorical'?: boolean;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetAvailableDistrictOptionsParams {
  /** @format int32 */
  examinerId: number;
  certificationType: CertificationTypeEnum;
}

export interface EndAffiliationParams {
  /** @format int32 */
  examinerDistrictId: number;
}

export interface GetExaminerDocumentsParams {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  'filter.examinerId'?: number;
  'filter.documentTypes'?: ExaminerDocumentType[];
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface DownloadExaminerDocumentParams {
  /** @format int32 */
  documentId?: number;
}

export interface DeleteExaminerDocumentParams {
  /** @format int32 */
  documentId?: number;
}

export interface AddExaminerDocumentPayload {
  /** @format binary */
  File?: File;
  ExaminerId?: string;
  ExaminerDocumentType?: string;
  DocumentName?: string;
  /** @format date-time */
  SignOff?: string | null;
}

export interface GetOnlineMeetingProviderAccountParams {
  /** @format int32 */
  examinerId: number;
}

export interface SaveOnlineMeetingProviderAccountParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetExaminersReportParams {
  'filter.certificationTypes'?: ReportCertificationType[];
  'filter.examinerTypes'?: number[];
  'filter.statuses'?: CertificationStatus[];
  'filter.regions'?: number[];
  'filter.countries'?: number[];
  'filter.centres'?: number[];
  'filter.idpCentres'?: number[];
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetExaminersPdfReportParams {
  'filter.certificationTypes'?: ReportCertificationType[];
  'filter.examinerTypes'?: number[];
  'filter.statuses'?: CertificationStatus[];
  'filter.regions'?: number[];
  'filter.countries'?: number[];
  'filter.centres'?: number[];
  'filter.idpCentres'?: number[];
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetExaminersExcelReportParams {
  'filter.certificationTypes'?: ReportCertificationType[];
  'filter.examinerTypes'?: number[];
  'filter.statuses'?: CertificationStatus[];
  'filter.regions'?: number[];
  'filter.countries'?: number[];
  'filter.centres'?: number[];
  'filter.idpCentres'?: number[];
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetExaminerTrainingsParams {
  /** @format int32 */
  examinerId: number;
}

export interface UpdateParams {
  /** @format int32 */
  id: number;
}

export interface GetHistoryParams {
  /** @format int32 */
  id: number;
}

export interface GetFileUrlParams {
  /** @format guid */
  storageId: string;
}

export interface GetParams5 {
  /** @format int32 */
  followUpId: number;
}

export interface CanAddFollowUpForMonitoringParams {
  /** @format int32 */
  monitoringId: number;
  monitoringType: MonitoringType;
}

export interface AddPayload {
  /** @format binary */
  File?: File;
}

export interface AddSpeakingMonitoringsPayload {
  /** @format binary */
  File?: File;
}

export interface AddOsmMonitoringResultsPayload {
  /** @format binary */
  File?: File;
}

export interface AddExaminerContactDetailsPayload {
  /** @format binary */
  File?: File;
}

export interface AddExaminerRolesPayload {
  /** @format binary */
  File?: File;
}

export interface AddOsmMonitoringArchivingPayload {
  /** @format binary */
  File?: File;
}

export interface AddExaminerCentresPayload {
  /** @format binary */
  File?: File;
}

export interface AddSpeakingCertificationsPayload {
  /** @format binary */
  File?: File;
}

export interface AddWritingCertificationsPayload {
  /** @format binary */
  File?: File;
}

export interface AddOdpAssessmentsPayload {
  /** @format binary */
  File?: File;
}

export interface AddOdpMonitoringsPayload {
  /** @format binary */
  File?: File;
}

export interface GetLifeSkillsCertificationsParams {
  /** @format int32 */
  page?: number | null;
  /** @format int32 */
  count?: number | null;
  isPagingSpecified?: boolean;
  filter?: LifeSkillsCertificationQuery;
  sortField?: string;
  sortDir?: SortDirectionCustom | null;
  isSortingSpecified?: boolean;
  /** @format int32 */
  examinerId: number;
}

export interface GetDetailsParams {
  /** @format int32 */
  certificationId: number;
}

export interface DeleteLifeSkillsCertificationParams {
  /** @format int32 */
  id?: number;
}

export interface GetNextLifeSkillsRecertificationDatesParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetLastPassedCertificationBasicDataParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetLevelsForExaminerParams {
  checkStatus?: boolean;
  /** @format int32 */
  examinerId: number;
}

export interface GetExaminerLifeSkillsMonitoringsParams {
  /** @format int32 */
  page?: number | null;
  /** @format int32 */
  count?: number | null;
  isPagingSpecified?: boolean;
  'filter.showDeleted'?: boolean;
  sortField?: string;
  sortDir?: SortDirectionCustom | null;
  isSortingSpecified?: boolean;
  /** @format int32 */
  examinerId: number;
}

export interface GetNextLifeSkillsMonitoringDatesParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetParams7 {
  /** @format int64 */
  id: number;
}

export interface DeleteParams2 {
  /** @format int64 */
  id: number;
}

export interface CanAddLifeSkillsMonitoringParams {
  /** @format int32 */
  examinerId: number;
}

export interface RestoreParams2 {
  /** @format int64 */
  id: number;
}

export interface GetDeletedDetailsParams {
  /** @format int64 */
  id: number;
}

export interface GetMonitoringDueReportParams {
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  'filter.monitoringTypes'?: ReportMonitoringType[];
  'filter.regions'?: number[];
  'filter.countries'?: number[];
  'filter.centres'?: number[];
  'filter.idpCentres'?: number[];
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetMonitoringDuePdfReportParams {
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  'filter.monitoringTypes'?: ReportMonitoringType[];
  'filter.regions'?: number[];
  'filter.countries'?: number[];
  'filter.centres'?: number[];
  'filter.idpCentres'?: number[];
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetMonitoringDueExcelReportParams {
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  'filter.monitoringTypes'?: ReportMonitoringType[];
  'filter.regions'?: number[];
  'filter.countries'?: number[];
  'filter.centres'?: number[];
  'filter.idpCentres'?: number[];
  'filter.centreType'?: CentreTypeSelector;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetAllParams {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  examinerId: number;
}

export interface CreateParams1 {
  /** @format int32 */
  examinerId: number;
}

export interface GetParams9 {
  /** @format int32 */
  examinerId: number;
  /** @format int32 */
  id: number;
}

export interface UpdateParams2 {
  /** @format int64 */
  id: number;
  /** @format int32 */
  examinerId: number;
}

export interface DeleteParams4 {
  /** @format int64 */
  id: number;
  /** @format int32 */
  examinerId: number;
}

export interface HasCompletedParams {
  /** @format int32 */
  examinerId: number;
}

export interface HasRequiredTrainingParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetOdpAssessmentReportParams {
  /** @format date */
  'filter.from'?: string;
  /** @format date */
  'filter.to'?: string;
  'filter.examinerNumber'?: string | null;
  'filter.completed'?: boolean | null;
  'filter.showDeleted'?: boolean;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetOdpAssessmentExcelReportParams {
  /** @format date */
  'filter.from'?: string;
  /** @format date */
  'filter.to'?: string;
  'filter.examinerNumber'?: string | null;
  'filter.completed'?: boolean | null;
  'filter.showDeleted'?: boolean;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetOdpAssessmentPdfReportParams {
  /** @format date */
  'filter.from'?: string;
  /** @format date */
  'filter.to'?: string;
  'filter.examinerNumber'?: string | null;
  'filter.completed'?: boolean | null;
  'filter.showDeleted'?: boolean;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetAllParams2 {
  /** @format int32 */
  examinerId: number;
}

export interface CreateParams3 {
  /** @format int32 */
  examinerId: number;
}

export interface DeleteParams6 {
  ids?: number[];
  /** @format int32 */
  examinerId: number;
}

export interface GetParams11 {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  id: number;
}

export interface UpdateParams4 {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  id: number;
}

export interface RestoreParams4 {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  id: number;
}

export interface CalculateNextStageParams {
  /** @format date */
  date?: string;
  /** @format int32 */
  examinerId: number;
}

export interface CalculateNextMonitoringDateParams {
  /** @format date */
  date?: string;
  result?: OdpMonitoringResult;
}

export interface GetNextMonitoringDateParams {
  /** @format int32 */
  examinerId: number;
}

export interface CanEditCustomNextMonitoringDateParams {
  /** @format date */
  monitoringDate?: string;
  /**
   * Strongly-typed identifier (underlying type: Int64)
   * @format int64
   * @example 1
   */
  monitoringId?: number | null;
  /** @format int32 */
  examinerId: number;
}

export interface AddFollowUpParams {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  id: number;
}

export interface UpdateFollowUpParams {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  id: number;
}

export interface RemoveFollowUpParams {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  id: number;
}

export interface CanAddFollowUpParams {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  id: number;
}

export interface GetOdpMonitoringReportParams {
  /** @format date */
  'filter.from'?: string;
  /** @format date */
  'filter.to'?: string;
  'filter.examinerNumber'?: string | null;
  'filter.reasons'?: OdpMonitoringReason[];
  'filter.results'?: OdpMonitoringResult[];
  'filter.stages'?: OdpMonitoringStage[];
  'filter.showDeleted'?: boolean;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetOdpMonitoringExcelReportParams {
  /** @format date */
  'filter.from'?: string;
  /** @format date */
  'filter.to'?: string;
  'filter.examinerNumber'?: string | null;
  'filter.reasons'?: OdpMonitoringReason[];
  'filter.results'?: OdpMonitoringResult[];
  'filter.stages'?: OdpMonitoringStage[];
  'filter.showDeleted'?: boolean;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetOdpMonitoringPdfReportParams {
  /** @format date */
  'filter.from'?: string;
  /** @format date */
  'filter.to'?: string;
  'filter.examinerNumber'?: string | null;
  'filter.reasons'?: OdpMonitoringReason[];
  'filter.results'?: OdpMonitoringResult[];
  'filter.stages'?: OdpMonitoringStage[];
  'filter.showDeleted'?: boolean;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface UpdateParams6 {
  /** @format int64 */
  id: number;
}

export interface GetDetailsParams2 {
  /** @format int64 */
  id: number;
}

export interface GetParams13 {
  /** @format int32 */
  examinerId: number;
}

export interface UpdateFollowUpParams2 {
  /** @format int64 */
  id: number;
}

export interface DeleteParams8 {
  /** @format int64 */
  id: number;
}

export interface RestoreArchivedParams {
  /** @format int64 */
  id: number;
}

export interface RestoreDeletedParams {
  /** @format int64 */
  id: number;
}

export interface GetAvailableOnlineSpeakingMonitoringResultsForExistingMonitoringParams {
  /** @format date */
  monitoringDate?: string;
  /** @format int64 */
  id: number;
}

export interface GetAvailableOnlineSpeakingMonitoringResultsForNewMonitoringParams {
  /** @format date */
  monitoringDate?: string;
  /** @format int32 */
  examinerId: number;
}

export interface UpdateOsmMonitoringParams {
  /** @format int64 */
  id: number;
}

export interface GetOsmMonitoringDetailsParams {
  /** @format int64 */
  id: number;
}

export interface GetOsmMonitoringsParams {
  /** @format int32 */
  examinerId: number;
}

export interface UpdateOsmMonitoringFollowUpParams {
  /** @format int64 */
  id: number;
}

export interface DeleteOsmMonitoringParams {
  /** @format int64 */
  id: number;
}

export interface RestoreArchivedParams2 {
  /** @format int64 */
  id: number;
}

export interface RestoreDeletedParams2 {
  /** @format int64 */
  id: number;
}

export interface GetAvailableOsmMonitoringResultsParams {
  /** @format int64 */
  id: number;
}

export interface GetOsmMonitoringTypesParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetAvailableOsmMonitoringResultsParams2 {
  /** @format date */
  dateOfMonitoring?: string;
  type: OsmMonitoringType;
  /** @format int32 */
  examinerId: number;
}

export interface GetOsmWritingMonitoringParams {
  'filter.monitoringType'?: number[];
  'filter.monitoringResult'?: number[];
  'filter.examinerIds'?: number[];
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  'filter.showLastMonitorings'?: boolean;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetOsmWritingPdfMonitoringParams {
  'filter.monitoringType'?: number[];
  'filter.monitoringResult'?: number[];
  'filter.examinerIds'?: number[];
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  'filter.showLastMonitorings'?: boolean;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetOsmWritingExcelMonitoringParams {
  'filter.monitoringType'?: number[];
  'filter.monitoringResult'?: number[];
  'filter.examinerIds'?: number[];
  /** @format date */
  'filter.startDate'?: string;
  /** @format date */
  'filter.endDate'?: string;
  'filter.showLastMonitorings'?: boolean;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetDetailsParams4 {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  id: number;
}

export interface DeleteParams10 {
  /** @format int64 */
  id: number;
  /** @format int32 */
  examinerId: number;
}

export interface CheckIfCertificationIsDeletableParams {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  certificationId: number;
}

export interface GetExaminerSpeakingCertificationsParams {
  /** @format int32 */
  page?: number | null;
  /** @format int32 */
  count?: number | null;
  isPagingSpecified?: boolean;
  filter?: SpeakingCertificationQuery;
  sortField?: string;
  sortDir?: SortDirectionCustom | null;
  isSortingSpecified?: boolean;
  /** @format int32 */
  examinerId: number;
}

export interface SaveCertificationParams {
  /** @format int32 */
  examinerId: number;
}

export interface DoCalculationParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetNextCertificationsDateParams {
  /** @format int32 */
  examinerId: number;
}

export interface IsNumberOfAttemptsExceededParams {
  /** @format int32 */
  examinerId: number;
  /** @format int32 */
  setId: number;
}

export interface IsGapBetweenAttemptsExceededParams {
  /** @format date */
  certificationDate?: string | null;
  /** @format int32 */
  examinerId: number;
  /** @format int32 */
  setId: number;
}

export interface GetLastPassedCertificationBasicDataParams2 {
  /** @format int32 */
  examinerId: number;
}

export interface GetExaminerSpeakingCertificationsParams2 {
  /** @format int32 */
  certificationId: number;
}

export interface GetExaminerSpeakingCertificationsParams4 {
  /** @format int32 */
  examinerId: number;
}

export interface GetNextMonitoringDateParams2 {
  /** @format int32 */
  examinerId: number;
}

export interface SaveParams3 {
  /** @format int32 */
  examinerId: number;
}

export interface GetExaminerSpeakingMonitoringsParams {
  /** @format int32 */
  page?: number | null;
  /** @format int32 */
  count?: number | null;
  isPagingSpecified?: boolean;
  'filter.showDeleted'?: boolean;
  sortField?: string;
  sortDir?: SortDirectionCustom | null;
  isSortingSpecified?: boolean;
  /** @format int32 */
  examinerId: number;
}

export interface GetParams15 {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  speakingMonitoringId: number;
}

export interface DeleteParams12 {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  speakingMonitoringId: number;
}

export interface RestoreParams6 {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  speakingMonitoringId: number;
}

export interface CanAddSpeakingMonitoringParams {
  /** @format int32 */
  examinerId: number;
}

export interface GetCustomNextMonitoringDateOptionsParams {
  /**
   * Strongly-typed identifier (underlying type: Int32)
   * @format int32
   * @example 1
   */
  examinerId?: number;
  /** @format date */
  monitoringDate?: string;
  /** @format int64 */
  monitoringId?: number;
  isIdp?: boolean;
  finalResult?: SpeakingMonitoringResult;
  reason?: SpeakingMonitoringReason | null;
  ratingResult?: SpeakingMonitoringResult | null;
  proceduresResult?: SpeakingMonitoringResult | null;
}

export interface GetCalculatedMonitoringStageParams {
  /** @format date */
  date?: string;
  /** @format int32 */
  examinerId: number;
}

export interface GetFollowUpParams {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  speakingMonitoringId: number;
}

export interface CreateFollowUpParams {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  speakingMonitoringId: number;
}

export interface UpdateFollowUpParams4 {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  speakingMonitoringId: number;
}

export interface DeleteFollowUpParams1 {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  speakingMonitoringId: number;
}

export interface CanAddFollowUpParams2 {
  /** @format int32 */
  examinerId: number;
  /** @format int64 */
  speakingMonitoringId: number;
}

export interface GetTrainingsAndStandardisationsParams {
  /** @format date */
  'filter.from'?: string | null;
  /** @format date */
  'filter.to'?: string | null;
  'filter.standardisedNotCertified'?: boolean;
  'filter.examinerIds'?: number[];
  'filter.trainingCategories'?: TrainingCategory[];
  'filter.trainingStatuses'?: ExaminerTrainingStatus[];
  'filter.trainingTypes'?: TrainingType[];
  'filter.organisingCentreIds'?: number[];
  'filter.mainSpeakingCentreIds'?: number[];
  'filter.mainWritingCentreIds'?: number[];
  'filter.trainingIds'?: number[];
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetTrainingsAndStandardisationsExcelReportParams {
  /** @format date */
  'filter.from'?: string | null;
  /** @format date */
  'filter.to'?: string | null;
  'filter.standardisedNotCertified'?: boolean;
  'filter.examinerIds'?: number[];
  'filter.trainingCategories'?: TrainingCategory[];
  'filter.trainingStatuses'?: ExaminerTrainingStatus[];
  'filter.trainingTypes'?: TrainingType[];
  'filter.organisingCentreIds'?: number[];
  'filter.mainSpeakingCentreIds'?: number[];
  'filter.mainWritingCentreIds'?: number[];
  'filter.trainingIds'?: number[];
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetTrainingsAndStandardisationsPdfReportParams {
  /** @format date */
  'filter.from'?: string | null;
  /** @format date */
  'filter.to'?: string | null;
  'filter.standardisedNotCertified'?: boolean;
  'filter.examinerIds'?: number[];
  'filter.trainingCategories'?: TrainingCategory[];
  'filter.trainingStatuses'?: ExaminerTrainingStatus[];
  'filter.trainingTypes'?: TrainingType[];
  'filter.organisingCentreIds'?: number[];
  'filter.mainSpeakingCentreIds'?: number[];
  'filter.mainWritingCentreIds'?: number[];
  'filter.trainingIds'?: number[];
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetUsersParams {
  'filter.searchText'?: string;
  'filter.centreIds'?: number[];
  'filter.regionIds'?: number[];
  /** @format int32 */
  'filter.roleId'?: number | null;
  /** @format int32 */
  'pagination.page'?: number;
  /** @format int32 */
  'pagination.pageSize'?: number;
  'sorting.sortField'?: string;
  'sorting.sortDir'?: SortDirection;
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface GetUserDetailsParams {
  /** @format int64 */
  userId: number;
}

export interface RevokeAccessParams {
  /** @format int64 */
  userId?: number;
}

export interface GetUserByEmailParams {
  email?: string;
}

export interface GetUsersAssignedOrRevokedParams {
  searchText?: string;
}

export interface GetExaminerWritingCertificationsParams {
  /** @format int32 */
  page?: number | null;
  /** @format int32 */
  count?: number | null;
  isPagingSpecified?: boolean;
  filter?: WritingCertificationQuery;
  sortField?: string;
  sortDir?: SortDirectionCustom | null;
  isSortingSpecified?: boolean;
  /** @format int32 */
  examinerId: number;
}

export interface DeleteParams14 {
  /** @format int64 */
  certificationId: number;
  /** @format int32 */
  examinerId: number;
}

export interface CanBeDeletedParams {
  /** @format int64 */
  certificationId: number;
}

export interface GetParams17 {
  /** @format int64 */
  id: number;
}

export interface GetNextCertificationsDateParams2 {
  /** @format int32 */
  examinerId: number;
}

export interface IsNumberOfAttemptsExceededParams2 {
  /** @format int32 */
  examinerId: number;
  /** @format int32 */
  setId: number;
}

export interface IsGapBetweenAttemptsExceededParams2 {
  /** @format date */
  certificationDate?: string | null;
  /** @format int32 */
  examinerId: number;
  /** @format int32 */
  setId: number;
}

export interface GetLastPassedCertificationBasicDataParams4 {
  /** @format int32 */
  examinerId: number;
}

export interface GetWritingCertificationRatesParams {
  /** @format int64 */
  certificationId: number;
}

export interface GetExaminerWritingCertificationsSetsParams {
  /** @format int32 */
  examinerId: number;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<
  AxiosRequestConfig,
  'data' | 'params' | 'url' | 'responseType'
> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<
  AxiosRequestConfig,
  'data' | 'cancelToken'
> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'http://localhost',
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title v3
 * @version 1.0.0
 * @baseUrl http://localhost
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  examinerHistoryReport = {
    /**
     * No description
     *
     * @tags ExaminerHistoryReport
     * @name GetExaminerHistoryPdfReport
     * @request GET:/api/reports/examiner-history/pdf
     */
    getExaminerHistoryPdfReport: (
      query: GetExaminerHistoryPdfReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/examiner-history/pdf`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  audit = {
    /**
     * No description
     *
     * @tags Audit
     * @name Get
     * @request GET:/api/audit
     */
    get: (query: GetParams = {}, params: RequestParams = {}) =>
      this.request<PagedResultOfAuditHistoryRecord, any>({
        path: `/api/audit`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  bulkActions = {
    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTrainingImport
     * @request GET:/api/bulk-actions/training-import/last
     */
    getLastTrainingImport: (params: RequestParams = {}) =>
      this.request<ImportFileRecord, any>({
        path: `/api/bulk-actions/training-import/last`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTenTrainingImports
     * @request GET:/api/bulk-actions/training-import/last-ten
     */
    getLastTenTrainingImports: (params: RequestParams = {}) =>
      this.request<ImportFileRecord[], any>({
        path: `/api/bulk-actions/training-import/last-ten`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastSpeakingMonitoringImport
     * @request GET:/api/bulk-actions/speaking-monitoring-import/last
     */
    getLastSpeakingMonitoringImport: (params: RequestParams = {}) =>
      this.request<ImportFileRecord, any>({
        path: `/api/bulk-actions/speaking-monitoring-import/last`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTenSpeakingMonitoringImports
     * @request GET:/api/bulk-actions/speaking-monitoring-import/last-ten
     */
    getLastTenSpeakingMonitoringImports: (params: RequestParams = {}) =>
      this.request<ImportFileRecord[], any>({
        path: `/api/bulk-actions/speaking-monitoring-import/last-ten`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastOsmMonitoringResultsImport
     * @request GET:/api/bulk-actions/osm-monitoring-results-import/last
     */
    getLastOsmMonitoringResultsImport: (params: RequestParams = {}) =>
      this.request<ImportFileRecord, any>({
        path: `/api/bulk-actions/osm-monitoring-results-import/last`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTenOsmMonitoringResultsImports
     * @request GET:/api/bulk-actions/osm-monitoring-results-import/last-ten
     */
    getLastTenOsmMonitoringResultsImports: (params: RequestParams = {}) =>
      this.request<ImportFileRecord[], any>({
        path: `/api/bulk-actions/osm-monitoring-results-import/last-ten`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastExaminerContactDetailsImport
     * @request GET:/api/bulk-actions/examiner-contact-details-import/last
     */
    getLastExaminerContactDetailsImport: (params: RequestParams = {}) =>
      this.request<ImportFileRecord, any>({
        path: `/api/bulk-actions/examiner-contact-details-import/last`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTenExaminerContactDetailsImports
     * @request GET:/api/bulk-actions/examiner-contact-details-import/last-ten
     */
    getLastTenExaminerContactDetailsImports: (params: RequestParams = {}) =>
      this.request<ImportFileRecord[], any>({
        path: `/api/bulk-actions/examiner-contact-details-import/last-ten`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastExaminerRolesImport
     * @request GET:/api/bulk-actions/examiner-roles-import/last
     */
    getLastExaminerRolesImport: (params: RequestParams = {}) =>
      this.request<ImportFileRecord, any>({
        path: `/api/bulk-actions/examiner-roles-import/last`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTenExaminerRolesImports
     * @request GET:/api/bulk-actions/examiner-roles-import/last-ten
     */
    getLastTenExaminerRolesImports: (params: RequestParams = {}) =>
      this.request<ImportFileRecord[], any>({
        path: `/api/bulk-actions/examiner-roles-import/last-ten`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastOsmMonitoringArchivingImport
     * @request GET:/api/bulk-actions/osm-monitoring-archiving-import/last
     */
    getLastOsmMonitoringArchivingImport: (params: RequestParams = {}) =>
      this.request<ImportFileRecord, any>({
        path: `/api/bulk-actions/osm-monitoring-archiving-import/last`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTenOsmMonitoringArchivingImports
     * @request GET:/api/bulk-actions/osm-monitoring-archiving-import/last-ten
     */
    getLastTenOsmMonitoringArchivingImports: (params: RequestParams = {}) =>
      this.request<ImportFileRecord[], any>({
        path: `/api/bulk-actions/osm-monitoring-archiving-import/last-ten`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastExaminerCentresImport
     * @request GET:/api/bulk-actions/examiner-centres-import/last
     */
    getLastExaminerCentresImport: (params: RequestParams = {}) =>
      this.request<ImportFileRecord, any>({
        path: `/api/bulk-actions/examiner-centres-import/last`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTenExaminerCentresImports
     * @request GET:/api/bulk-actions/examiner-centres-import/last-ten
     */
    getLastTenExaminerCentresImports: (params: RequestParams = {}) =>
      this.request<ImportFileRecord[], any>({
        path: `/api/bulk-actions/examiner-centres-import/last-ten`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastSpeakingCertificationsImport
     * @request GET:/api/bulk-actions/speaking-certifications-import/last
     */
    getLastSpeakingCertificationsImport: (params: RequestParams = {}) =>
      this.request<ImportFileRecord, any>({
        path: `/api/bulk-actions/speaking-certifications-import/last`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTenSpeakingCertificationsImports
     * @request GET:/api/bulk-actions/speaking-certifications-import/last-ten
     */
    getLastTenSpeakingCertificationsImports: (params: RequestParams = {}) =>
      this.request<ImportFileRecord[], any>({
        path: `/api/bulk-actions/speaking-certifications-import/last-ten`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastWritingCertificationsImport
     * @request GET:/api/bulk-actions/writing-certifications-import/last
     */
    getLastWritingCertificationsImport: (params: RequestParams = {}) =>
      this.request<ImportFileRecord, any>({
        path: `/api/bulk-actions/writing-certifications-import/last`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTenWritingCertificationsImports
     * @request GET:/api/bulk-actions/writing-certifications-import/last-ten
     */
    getLastTenWritingCertificationsImports: (params: RequestParams = {}) =>
      this.request<ImportFileRecord[], any>({
        path: `/api/bulk-actions/writing-certifications-import/last-ten`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastOdpAssessmentImport
     * @request GET:/api/bulk-actions/odp-assessment-import/last
     */
    getLastOdpAssessmentImport: (params: RequestParams = {}) =>
      this.request<ImportFileRecord, any>({
        path: `/api/bulk-actions/odp-assessment-import/last`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTenOdpAssessmentImports
     * @request GET:/api/bulk-actions/odp-assessment-import/last-ten
     */
    getLastTenOdpAssessmentImports: (params: RequestParams = {}) =>
      this.request<ImportFileRecord[], any>({
        path: `/api/bulk-actions/odp-assessment-import/last-ten`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastOdpMonitoringImport
     * @request GET:/api/bulk-actions/odp-monitoring-import/last
     */
    getLastOdpMonitoringImport: (params: RequestParams = {}) =>
      this.request<ImportFileRecord, any>({
        path: `/api/bulk-actions/odp-monitoring-import/last`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BulkActions
     * @name GetLastTenOdpMonitoringImports
     * @request GET:/api/bulk-actions/odp-monitoring-import/last-ten
     */
    getLastTenOdpMonitoringImports: (params: RequestParams = {}) =>
      this.request<ImportFileRecord[], any>({
        path: `/api/bulk-actions/odp-monitoring-import/last-ten`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  canary = {
    /**
     * No description
     *
     * @tags Canary
     * @name Get
     * @request GET:/api/canary
     */
    get: (params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/canary`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Canary
     * @name Info
     * @request GET:/Info
     */
    info: (params: RequestParams = {}) =>
      this.request<ApiInfo, any>({
        path: `/Info`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  centre = {
    /**
     * No description
     *
     * @tags Centre
     * @name GetAllCentres
     * @request GET:/api/centres
     */
    getAllCentres: (query: GetAllCentresParams = {}, params: RequestParams = {}) =>
      this.request<CentresResponse, any>({
        path: `/api/centres`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Centre
     * @name GetCentresForUser
     * @request GET:/api/centres/user/{userId}
     */
    getCentresForUser: ({ userId }: GetCentresForUserParams, params: RequestParams = {}) =>
      this.request<CentresForUserResponse, any>({
        path: `/api/centres/user/${userId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Centre
     * @name IsHubCentre
     * @request GET:/api/centres/isHub
     */
    isHubCentre: (query: IsHubCentreParams = {}, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/centres/isHub`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  certificationsDueReport = {
    /**
     * No description
     *
     * @tags CertificationsDueReport
     * @name GetCertificationsDueReport
     * @request GET:/api/reports/certifications-due
     */
    getCertificationsDueReport: (
      query: GetCertificationsDueReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfCertificationsDueReportResponse, any>({
        path: `/api/reports/certifications-due`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CertificationsDueReport
     * @name GetCertificationsDuePdfReport
     * @request GET:/api/reports/certifications-due/pdf
     */
    getCertificationsDuePdfReport: (
      query: GetCertificationsDuePdfReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/certifications-due/pdf`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CertificationsDueReport
     * @name GetCertificationsDueExcelReport
     * @request GET:/api/reports/certifications-due/excel
     */
    getCertificationsDueExcelReport: (
      query: GetCertificationsDueExcelReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/certifications-due/excel`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  certificationStatusHistory = {
    /**
     * No description
     *
     * @tags CertificationStatusHistory
     * @name GetCertificationStatusLastChange
     * @request GET:/api/certification-status-history/examiner/{examinerId}/last-change
     */
    getCertificationStatusLastChange: (
      { examinerId }: GetCertificationStatusLastChangeParams,
      params: RequestParams = {}
    ) =>
      this.request<CertificationStatusLastChangeResponse, any>({
        path: `/api/certification-status-history/examiner/${examinerId}/last-change`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  certificationType = {
    /**
     * No description
     *
     * @tags CertificationType
     * @name GetCertificationTypeStatuses
     * @request GET:/api/certificationtypes/statuses
     */
    getCertificationTypeStatuses: (params: RequestParams = {}) =>
      this.request<CertificationTypeStatuses[], any>({
        path: `/api/certificationtypes/statuses`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  communication = {
    /**
     * No description
     *
     * @tags Communication
     * @name GetEmails
     * @request GET:/api/communication/{examinerId}
     */
    getEmails: ({ examinerId }: GetEmailsParams, params: RequestParams = {}) =>
      this.request<CommunicationEmailsResponse, any>({
        path: `/api/communication/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name GetEmail
     * @request GET:/api/communication/email/{messageGuid}
     */
    getEmail: ({ messageGuid }: GetEmailParams, params: RequestParams = {}) =>
      this.request<CommunicationEmailResponse, any>({
        path: `/api/communication/email/${messageGuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name ResendEmail
     * @request POST:/api/communication/resend
     */
    resendEmail: (data: ResendEmailRequest, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/communication/resend`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name GetEmailEml
     * @request GET:/api/communication/email/{messageGuid}/eml
     */
    getEmailEml: ({ messageGuid }: GetEmailEmlParams, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/communication/email/${messageGuid}/eml`,
        method: 'GET',
        ...params,
      }),
  };
  country = {
    /**
     * No description
     *
     * @tags Country
     * @name GetCountries
     * @request GET:/api/countries
     */
    getCountries: (query: GetCountriesParams = {}, params: RequestParams = {}) =>
      this.request<Country[], any>({
        path: `/api/countries`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Country
     * @name GetAllCountries
     * @request GET:/api/countries/AllCountries
     */
    getAllCountries: (params: RequestParams = {}) =>
      this.request<Country[], any>({
        path: `/api/countries/AllCountries`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  dashboard = {
    /**
     * No description
     *
     * @tags Dashboard
     * @name GetDashboard
     * @request GET:/api/dashboard-v2
     */
    getDashboard: (query: GetDashboardParams = {}, params: RequestParams = {}) =>
      this.request<DashboardResponse, any>({
        path: `/api/dashboard-v2`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  disciplinaryActionDueReport = {
    /**
     * No description
     *
     * @tags DisciplinaryActionDueReport
     * @name GetDisciplinaryActionDueReport
     * @request POST:/api/reports/disciplinary-action-due
     */
    getDisciplinaryActionDueReport: (
      data: PagedAndSortedQueryParametersOfDisciplinaryActionDueReportRequest,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfDisciplinaryActionDueReportRecordDto, any>({
        path: `/api/reports/disciplinary-action-due`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DisciplinaryActionDueReport
     * @name GetDisciplinaryActionDueExcelReport
     * @request GET:/api/reports/disciplinary-action-due/excel
     */
    getDisciplinaryActionDueExcelReport: (
      query: GetDisciplinaryActionDueExcelReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/disciplinary-action-due/excel`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DisciplinaryActionDueReport
     * @name GetDisciplinaryActionDuePdfReport
     * @request GET:/api/reports/disciplinary-action-due/pdf
     */
    getDisciplinaryActionDuePdfReport: (
      query: GetDisciplinaryActionDuePdfReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/disciplinary-action-due/pdf`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  disciplinary = {
    /**
     * No description
     *
     * @tags Disciplinary
     * @name GetDisciplinaries
     * @request GET:/api/disciplinary/list/{examinerId}
     */
    getDisciplinaries: (
      { examinerId, ...query }: GetDisciplinariesParams,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfDisciplinary, any>({
        path: `/api/disciplinary/list/${examinerId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Disciplinary
     * @name GetDisciplinaryReviewDate
     * @request GET:/api/disciplinary/disciplinaryReviewDate/{examinerId}
     */
    getDisciplinaryReviewDate: (
      { examinerId }: GetDisciplinaryReviewDateParams,
      params: RequestParams = {}
    ) =>
      this.request<string | null, any>({
        path: `/api/disciplinary/disciplinaryReviewDate/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Disciplinary
     * @name SaveDisciplinary
     * @request POST:/api/disciplinary/details/save/{examinerId}
     */
    saveDisciplinary: (
      { examinerId }: SaveDisciplinaryParams,
      data: SaveDisciplinaryRequest,
      params: RequestParams = {}
    ) =>
      this.request<number, any>({
        path: `/api/disciplinary/details/save/${examinerId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  district = {
    /**
     * No description
     *
     * @tags District
     * @name GetDistricts
     * @request GET:/api/districts/{centreId}
     */
    getDistricts: ({ centreId }: GetDistrictsParams, params: RequestParams = {}) =>
      this.request<District[], any>({
        path: `/api/districts/${centreId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  eorSpeakingMonitoring = {
    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name Save
     * @request POST:/api/EorSpeakingMonitorings
     */
    save: (data: EorMonitoringGroupDetails, params: RequestParams = {}) =>
      this.request<EorMonitoringDetails, any>({
        path: `/api/EorSpeakingMonitorings`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name GetPreSaveWarning
     * @request POST:/api/EorSpeakingMonitorings/preSave
     */
    getPreSaveWarning: (data: EorMonitoringGroupDetails, params: RequestParams = {}) =>
      this.request<EorSpeakingSuspension, any>({
        path: `/api/EorSpeakingMonitorings/preSave`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name AddStage
     * @request POST:/api/EorSpeakingMonitorings/addStage
     */
    addStage: (data: EorMonitoringNewStageDetails, params: RequestParams = {}) =>
      this.request<EorMonitoringDetails, any>({
        path: `/api/EorSpeakingMonitorings/addStage`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name GetExaminerEorSpeakingMonitorings
     * @request GET:/api/EorSpeakingMonitorings/examiner/{examinerId}
     */
    getExaminerEorSpeakingMonitorings: (
      { examinerId, ...query }: GetExaminerEorSpeakingMonitoringsParams,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfEorSpeakingMonitoringGroup, any>({
        path: `/api/EorSpeakingMonitorings/examiner/${examinerId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name Get
     * @request GET:/api/EorSpeakingMonitorings/{id}
     */
    get: ({ id }: GetParams3, params: RequestParams = {}) =>
      this.request<EorMonitoringGroupDetails, any>({
        path: `/api/EorSpeakingMonitorings/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name Delete
     * @request POST:/api/EorSpeakingMonitorings/{id}/delete
     */
    delete: ({ id }: DeleteParams, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/EorSpeakingMonitorings/${id}/delete`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name Restore
     * @request POST:/api/EorSpeakingMonitorings/{id}/restore
     */
    restore: ({ id }: RestoreParams, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/EorSpeakingMonitorings/${id}/restore`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name GetNextEorSpeakingMonitoringStage
     * @request GET:/api/EorSpeakingMonitorings/nextMonitoringStage
     */
    getNextEorSpeakingMonitoringStage: (
      query: GetNextEorSpeakingMonitoringStageParams = {},
      params: RequestParams = {}
    ) =>
      this.request<EorMonitoringStage, any>({
        path: `/api/EorSpeakingMonitorings/nextMonitoringStage`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name GetEorSpeakingMonitoringReasons
     * @request GET:/api/EorSpeakingMonitorings/reasons
     */
    getEorSpeakingMonitoringReasons: (params: RequestParams = {}) =>
      this.request<EorMonitoringReason[], any>({
        path: `/api/EorSpeakingMonitorings/reasons`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name GetEorSpeakingMonitoringResults
     * @request GET:/api/EorSpeakingMonitorings/results
     */
    getEorSpeakingMonitoringResults: (params: RequestParams = {}) =>
      this.request<EorMonitoringResult[], any>({
        path: `/api/EorSpeakingMonitorings/results`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name GetEorSpeakingMonitoringTypes
     * @request GET:/api/EorSpeakingMonitorings/types
     */
    getEorSpeakingMonitoringTypes: (params: RequestParams = {}) =>
      this.request<EorMonitoringType[], any>({
        path: `/api/EorSpeakingMonitorings/types`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoring
     * @name GetEorSpeakingMonitoringStages
     * @request GET:/api/EorSpeakingMonitorings/stages
     */
    getEorSpeakingMonitoringStages: (params: RequestParams = {}) =>
      this.request<EorMonitoringStage[], any>({
        path: `/api/EorSpeakingMonitorings/stages`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  eorSpeakingMonitoringReport = {
    /**
     * No description
     *
     * @tags EorSpeakingMonitoringReport
     * @name GetEorSpeakingMonitoringReport
     * @request GET:/api/reports/eor-speaking-monitoring
     */
    getEorSpeakingMonitoringReport: (
      query: GetEorSpeakingMonitoringReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfEorSpeakingMonitoringReportResponse, any>({
        path: `/api/reports/eor-speaking-monitoring`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoringReport
     * @name GetEorSpeakingMonitoringPdfReport
     * @request GET:/api/reports/eor-speaking-monitoring/pdf
     */
    getEorSpeakingMonitoringPdfReport: (
      query: GetEorSpeakingMonitoringPdfReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/eor-speaking-monitoring/pdf`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags EorSpeakingMonitoringReport
     * @name GetEorSpeakingMonitoringExcelReport
     * @request GET:/api/reports/eor-speaking-monitoring/excel
     */
    getEorSpeakingMonitoringExcelReport: (
      query: GetEorSpeakingMonitoringExcelReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/eor-speaking-monitoring/excel`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  examinerCentre = {
    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name GetExaminerCentreList
     * @request GET:/api/examinercentre/examiner/list
     */
    getExaminerCentreList: (query: GetExaminerCentreListParams = {}, params: RequestParams = {}) =>
      this.request<PagedResultOfExaminerCentreHistoryRecord, any>({
        path: `/api/examinercentre/examiner/list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name AddBcMainCentreAffiliation
     * @request POST:/api/examinercentre/examiner/main
     */
    addBcMainCentreAffiliation: (data: ExaminerCentreAssignment, params: RequestParams = {}) =>
      this.request<ExaminerCentre, any>({
        path: `/api/examinercentre/examiner/main`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name EndMainCentreAffiliation
     * @request POST:/api/examinercentre/examiner/main/endaffiliation
     */
    endMainCentreAffiliation: (data: ExaminerMainCentreAssignment, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/examinercentre/examiner/main/endaffiliation`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name AddSharedCentreAffiliation
     * @request POST:/api/examinercentre/examiner/shared
     */
    addSharedCentreAffiliation: (data: ExaminerCentreAssignment, params: RequestParams = {}) =>
      this.request<ExaminerCentre, any>({
        path: `/api/examinercentre/examiner/shared`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name EndSharedCentreAffiliation
     * @request POST:/api/examinercentre/examiner/shared/endaffiliation
     */
    endSharedCentreAffiliation: (data: ExaminerCentreAssignment, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/examinercentre/examiner/shared/endaffiliation`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name AddIdpCentreAffiliation
     * @request POST:/api/examinercentre/examiner/idp
     */
    addIdpCentreAffiliation: (data: NewExaminerIdpCentreAssignment, params: RequestParams = {}) =>
      this.request<ExaminerIdpCentre, any>({
        path: `/api/examinercentre/examiner/idp`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name EndIdpCentreAffiliation
     * @request POST:/api/examinercentre/examiner/idp/endaffiliation
     */
    endIdpCentreAffiliation: (data: ExaminerIdpCentreAssignment, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/examinercentre/examiner/idp/endaffiliation`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name CheckIfAssignedToAnyCentre
     * @request GET:/api/examinercentre/examiner/centre/{examinerId}/certificationType/{certificationType}
     */
    checkIfAssignedToAnyCentre: (
      { examinerId, certificationType }: CheckIfAssignedToAnyCentreParams,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/examinercentre/examiner/centre/${examinerId}/certificationType/${certificationType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name GetAvailableCentreOptions
     * @request GET:/api/examinercentre/centres/{examinerId}/certificationType/{certificationType}
     */
    getAvailableCentreOptions: (
      { examinerId, certificationType }: GetAvailableCentreOptionsParams,
      params: RequestParams = {}
    ) =>
      this.request<Centre[], any>({
        path: `/api/examinercentre/centres/${examinerId}/certificationType/${certificationType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name GetIdpCentreSuggestions
     * @request GET:/api/examinercentre/idpcentres
     */
    getIdpCentreSuggestions: (
      query: GetIdpCentreSuggestionsParams = {},
      params: RequestParams = {}
    ) =>
      this.request<IdpCentre[], any>({
        path: `/api/examinercentre/idpcentres`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name GetIdpCentreNumberSuggestions
     * @request GET:/api/examinercentre/idpcentres/number
     */
    getIdpCentreNumberSuggestions: (
      query: GetIdpCentreNumberSuggestionsParams = {},
      params: RequestParams = {}
    ) =>
      this.request<string[], any>({
        path: `/api/examinercentre/idpcentres/number`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name GetExaminerMainCentre
     * @request GET:/api/examinercentre/examiner/main/details/{examinerId}/{certificationType}
     */
    getExaminerMainCentre: (
      { examinerId, certificationType }: GetExaminerMainCentreParams,
      params: RequestParams = {}
    ) =>
      this.request<MainCentre, any>({
        path: `/api/examinercentre/examiner/main/details/${examinerId}/${certificationType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name GetExaminerSharedCentres
     * @request GET:/api/examinercentre/examiner/list/shared/{examinerId}/certificationType/{certificationType}
     */
    getExaminerSharedCentres: (
      { examinerId, certificationType }: GetExaminerSharedCentresParams,
      params: RequestParams = {}
    ) =>
      this.request<ExaminerCentreOption[], any>({
        path: `/api/examinercentre/examiner/list/shared/${examinerId}/certificationType/${certificationType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name GetExaminerIdpSharedCentres
     * @request GET:/api/examinercentre/examiner/list/shared/idp/{examinerId}/certificationType/{certificationType}
     */
    getExaminerIdpSharedCentres: (
      { examinerId, certificationType }: GetExaminerIdpSharedCentresParams,
      params: RequestParams = {}
    ) =>
      this.request<ExaminerCentreOption[], any>({
        path: `/api/examinercentre/examiner/list/shared/idp/${examinerId}/certificationType/${certificationType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name ReplaceMainCentre
     * @request POST:/api/examinercentre/examiner/main/replace
     */
    replaceMainCentre: (data: ExaminerMainCentreAssignment, params: RequestParams = {}) =>
      this.request<MainCentre, any>({
        path: `/api/examinercentre/examiner/main/replace`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCentre
     * @name ValidateMainCentreAssignmentForCertificationType
     * @request GET:/api/examinercentre/examiner/main/validate/{examinerId}/{certificationType}
     */
    validateMainCentreAssignmentForCertificationType: (
      { examinerId, certificationType }: ValidateMainCentreAssignmentForCertificationTypeParams,
      params: RequestParams = {}
    ) =>
      this.request<MainCentreAssignmentValidationResult, any>({
        path: `/api/examinercentre/examiner/main/validate/${examinerId}/${certificationType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  examinerCertificationStatus = {
    /**
     * No description
     *
     * @tags ExaminerCertificationStatus
     * @name GetExaminerStatus
     * @request GET:/api/examinercertificationstatuses/{examinerId}
     */
    getExaminerStatus: ({ examinerId }: GetExaminerStatusParams, params: RequestParams = {}) =>
      this.request<ExaminerCertificationStatusWithDates, any>({
        path: `/api/examinercertificationstatuses/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCertificationStatus
     * @name SaveExaminerStatus
     * @request POST:/api/examinercertificationstatuses
     */
    saveExaminerStatus: (data: ExaminerCertificationStatus, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/examinercertificationstatuses`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCertificationStatus
     * @name GetExaminerStatusHistory
     * @request GET:/api/examinercertificationstatuses/history
     */
    getExaminerStatusHistory: (
      query: GetExaminerStatusHistoryParams = {},
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfCertificationStatusHistory, any>({
        path: `/api/examinercertificationstatuses/history`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerCertificationStatus
     * @name GetOnlineSpeakingStatusHistory
     * @request GET:/api/examinercertificationstatuses/{examinerId}/online-speaking-history
     */
    getOnlineSpeakingStatusHistory: (
      { examinerId }: GetOnlineSpeakingStatusHistoryParams,
      params: RequestParams = {}
    ) =>
      this.request<OnlineSpeakingStatusHistoryResult[], any>({
        path: `/api/examinercertificationstatuses/${examinerId}/online-speaking-history`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  examiner = {
    /**
     * No description
     *
     * @tags Examiner
     * @name GetExaminersV2
     * @request GET:/api/examiners-v2
     */
    getExaminersV2: (query: GetExaminersV2Params = {}, params: RequestParams = {}) =>
      this.request<PagedResultOfExaminerDto, any>({
        path: `/api/examiners-v2`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Examiner
     * @name GetExaminerDetails
     * @request GET:/api/examiners/{examinerId}
     */
    getExaminerDetails: ({ examinerId }: GetExaminerDetailsParams, params: RequestParams = {}) =>
      this.request<ExaminerDetails, any>({
        path: `/api/examiners/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Examiner
     * @name UpdateExaminer
     * @request PUT:/api/examiners/{examinerId}
     */
    updateExaminer: (
      { examinerId }: UpdateExaminerParams,
      data: CreateOrUpdateExaminerDto,
      params: RequestParams = {}
    ) =>
      this.request<ExaminerDetails, any>({
        path: `/api/examiners/${examinerId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Examiner
     * @name CreateExaminer
     * @request POST:/api/examiners
     */
    createExaminer: (data: CreateOrUpdateExaminerDto, params: RequestParams = {}) =>
      this.request<ExaminerDetails, any>({
        path: `/api/examiners`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Examiner
     * @name GetExaminerContactDetails
     * @request GET:/api/examiners/contactData/{examinerId}
     */
    getExaminerContactDetails: (
      { examinerId }: GetExaminerContactDetailsParams,
      params: RequestParams = {}
    ) =>
      this.request<ExaminerContactDetails, any>({
        path: `/api/examiners/contactData/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Examiner
     * @name SaveExaminerContactDetails
     * @request POST:/api/examiners/contactData/save/{examinerId}
     */
    saveExaminerContactDetails: (
      { examinerId }: SaveExaminerContactDetailsParams,
      data: ExaminerContactDetails,
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/examiners/contactData/save/${examinerId}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Examiner
     * @name ValidatePostCodeAndGetAddress
     * @request POST:/api/examiners/contactData/validate/post-code
     */
    validatePostCodeAndGetAddress: (
      data: ExaminerAddress,
      query: ValidatePostCodeAndGetAddressParams = {},
      params: RequestParams = {}
    ) =>
      this.request<ExaminerAddress, any>({
        path: `/api/examiners/contactData/validate/post-code`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Examiner
     * @name GetTrainers
     * @request GET:/api/examiners/trainers
     */
    getTrainers: (params: RequestParams = {}) =>
      this.request<Trainer[], any>({
        path: `/api/examiners/trainers`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Examiner
     * @name GetExaminerRoles
     * @request GET:/api/examiners/roles
     */
    getExaminerRoles: (params: RequestParams = {}) =>
      this.request<ProductFamilyGroup[], any>({
        path: `/api/examiners/roles`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  examinerDistrict = {
    /**
     * No description
     *
     * @tags ExaminerDistrict
     * @name GetExaminerDistrictList
     * @request GET:/api/examinerdistrict/examiner/list
     */
    getExaminerDistrictList: (
      query: GetExaminerDistrictListParams = {},
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfExaminerDistrictHistoryRecord, any>({
        path: `/api/examinerdistrict/examiner/list`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerDistrict
     * @name GetAvailableDistrictOptions
     * @request GET:/api/examinerdistrict/districts/{examinerId}/{certificationType}
     */
    getAvailableDistrictOptions: (
      { examinerId, certificationType }: GetAvailableDistrictOptionsParams,
      params: RequestParams = {}
    ) =>
      this.request<District[], any>({
        path: `/api/examinerdistrict/districts/${examinerId}/${certificationType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerDistrict
     * @name AddAffiliation
     * @request POST:/api/examinerdistrict/examiner
     */
    addAffiliation: (data: ExaminerDistrictAssignment, params: RequestParams = {}) =>
      this.request<ExaminerDistrict, any>({
        path: `/api/examinerdistrict/examiner`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerDistrict
     * @name EndAffiliation
     * @request POST:/api/examinerdistrict/examiner/endaffiliation/{examinerDistrictId}
     */
    endAffiliation: ({ examinerDistrictId }: EndAffiliationParams, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/examinerdistrict/examiner/endaffiliation/${examinerDistrictId}`,
        method: 'POST',
        ...params,
      }),
  };
  examinerDocument = {
    /**
     * No description
     *
     * @tags ExaminerDocument
     * @name GetExaminerDocuments
     * @request GET:/api/examinerdocument
     */
    getExaminerDocuments: (query: GetExaminerDocumentsParams = {}, params: RequestParams = {}) =>
      this.request<PagedResultOfExaminerDocument, any>({
        path: `/api/examinerdocument`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerDocument
     * @name DownloadExaminerDocument
     * @request GET:/api/examinerdocument/download
     */
    downloadExaminerDocument: (
      query: DownloadExaminerDocumentParams = {},
      params: RequestParams = {}
    ) =>
      this.request<FileUrl, any>({
        path: `/api/examinerdocument/download`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerDocument
     * @name DeleteExaminerDocument
     * @request DELETE:/api/examinerdocument/delete
     */
    deleteExaminerDocument: (
      query: DeleteExaminerDocumentParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/examinerdocument/delete`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerDocument
     * @name AddExaminerDocument
     * @request POST:/api/examinerdocument/add
     */
    addExaminerDocument: (data: AddExaminerDocumentPayload, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/examinerdocument/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  };
  examinerOnlineMeetingProvider = {
    /**
     * No description
     *
     * @tags ExaminerOnlineMeetingProvider
     * @name GetOnlineMeetingProviderAccount
     * @request GET:/api/examiners/{examinerId}/online-meeting-provider
     */
    getOnlineMeetingProviderAccount: (
      { examinerId }: GetOnlineMeetingProviderAccountParams,
      params: RequestParams = {}
    ) =>
      this.request<ExaminerOnlineMeetingProviderAccount, any>({
        path: `/api/examiners/${examinerId}/online-meeting-provider`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerOnlineMeetingProvider
     * @name SaveOnlineMeetingProviderAccount
     * @request POST:/api/examiners/{examinerId}/online-meeting-provider
     */
    saveOnlineMeetingProviderAccount: (
      { examinerId }: SaveOnlineMeetingProviderAccountParams,
      data: OnlineMeetingProviderAccount,
      params: RequestParams = {}
    ) =>
      this.request<ExaminerOnlineMeetingProviderAccount, any>({
        path: `/api/examiners/${examinerId}/online-meeting-provider`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  examinerReport = {
    /**
     * No description
     *
     * @tags ExaminerReport
     * @name GetExaminersReport
     * @request GET:/api/reports/examiner
     */
    getExaminersReport: (query: GetExaminersReportParams = {}, params: RequestParams = {}) =>
      this.request<PagedResultOfExaminersReportResponse, any>({
        path: `/api/reports/examiner`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerReport
     * @name GetExaminersPdfReport
     * @request GET:/api/reports/examiner/pdf
     */
    getExaminersPdfReport: (query: GetExaminersPdfReportParams = {}, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/reports/examiner/pdf`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerReport
     * @name GetExaminersExcelReport
     * @request GET:/api/reports/examiner/excel
     */
    getExaminersExcelReport: (
      query: GetExaminersExcelReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/examiner/excel`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  examinerTraining = {
    /**
     * No description
     *
     * @tags ExaminerTraining
     * @name GetExaminerTrainings
     * @request GET:/api/examiner-trainings/examiner/{examinerId}
     */
    getExaminerTrainings: (
      { examinerId }: GetExaminerTrainingsParams,
      params: RequestParams = {}
    ) =>
      this.request<ExaminerTrainingsResponse, any>({
        path: `/api/examiner-trainings/examiner/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerTraining
     * @name Create
     * @request POST:/api/examiner-trainings
     */
    create: (data: CreateExaminerTrainingRequest, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/examiner-trainings`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerTraining
     * @name Update
     * @request POST:/api/examiner-trainings/{id}
     */
    update: (
      { id }: UpdateParams,
      data: UpdateExaminerTrainingRequest,
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/examiner-trainings/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExaminerTraining
     * @name GetHistory
     * @request GET:/api/examiner-trainings/{id}/history
     */
    getHistory: ({ id }: GetHistoryParams, params: RequestParams = {}) =>
      this.request<ExaminerTrainingHistoryResponse, any>({
        path: `/api/examiner-trainings/${id}/history`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  file = {
    /**
     * No description
     *
     * @tags File
     * @name MarkAsInfected
     * @request POST:/api/File/MarkAsInfected
     */
    markAsInfected: (data: InfectedFile, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/File/MarkAsInfected`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name GetFileUrl
     * @request GET:/api/file/download/storage-id/{storageId}
     */
    getFileUrl: ({ storageId }: GetFileUrlParams, params: RequestParams = {}) =>
      this.request<FileUrl, any>({
        path: `/api/file/download/storage-id/${storageId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  followUp = {
    /**
     * No description
     *
     * @tags FollowUp
     * @name Get
     * @request GET:/api/followup/{followUpId}
     */
    get: ({ followUpId }: GetParams5, params: RequestParams = {}) =>
      this.request<FollowUpDetails, any>({
        path: `/api/followup/${followUpId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FollowUp
     * @name Save
     * @request POST:/api/followup
     */
    save: (data: FollowUpDetails, params: RequestParams = {}) =>
      this.request<FollowUpDetails, any>({
        path: `/api/followup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FollowUp
     * @name CanAddFollowUpForMonitoring
     * @request GET:/api/followup/{monitoringType}/{monitoringId}/availability
     */
    canAddFollowUpForMonitoring: (
      { monitoringId, monitoringType }: CanAddFollowUpForMonitoringParams,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/followup/${monitoringType}/${monitoringId}/availability`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FollowUp
     * @name DeleteFollowUp
     * @request POST:/api/followup/delete
     */
    deleteFollowUp: (data: FollowUpDetails, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/followup/delete`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  import = {
    /**
     * No description
     *
     * @tags Import
     * @name Add
     * @request POST:/api/importFile/trainingStandardisation/add
     */
    add: (data: AddPayload, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/importFile/trainingStandardisation/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name AddSpeakingMonitorings
     * @request POST:/api/importFile/speakingMonitoring/add
     */
    addSpeakingMonitorings: (data: AddSpeakingMonitoringsPayload, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/importFile/speakingMonitoring/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name AddOsmMonitoringResults
     * @request POST:/api/importFile/osmMonitoringResults/add
     */
    addOsmMonitoringResults: (data: AddOsmMonitoringResultsPayload, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/importFile/osmMonitoringResults/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name AddExaminerContactDetails
     * @request POST:/api/importFile/examinerContactDetails/add
     */
    addExaminerContactDetails: (
      data: AddExaminerContactDetailsPayload,
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/importFile/examinerContactDetails/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name AddExaminerRoles
     * @request POST:/api/importFile/examinerRoles/add
     */
    addExaminerRoles: (data: AddExaminerRolesPayload, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/importFile/examinerRoles/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name AddOsmMonitoringArchiving
     * @request POST:/api/importFile/osmMonitoringArchiving/add
     */
    addOsmMonitoringArchiving: (
      data: AddOsmMonitoringArchivingPayload,
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/importFile/osmMonitoringArchiving/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name AddExaminerCentres
     * @request POST:/api/importFile/examinerCentres/add
     */
    addExaminerCentres: (data: AddExaminerCentresPayload, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/importFile/examinerCentres/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name AddSpeakingCertifications
     * @request POST:/api/importFile/speakingCertifications/add
     */
    addSpeakingCertifications: (
      data: AddSpeakingCertificationsPayload,
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/importFile/speakingCertifications/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name AddWritingCertifications
     * @request POST:/api/importFile/writingCertifications/add
     */
    addWritingCertifications: (data: AddWritingCertificationsPayload, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/importFile/writingCertifications/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name AddOdpAssessments
     * @request POST:/api/importFile/odpAssessments/add
     */
    addOdpAssessments: (data: AddOdpAssessmentsPayload, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/importFile/odpAssessments/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name AddOdpMonitorings
     * @request POST:/api/importFile/odpMonitorings/add
     */
    addOdpMonitorings: (data: AddOdpMonitoringsPayload, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/importFile/odpMonitorings/add`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  };
  lifeSkillsCertification = {
    /**
     * No description
     *
     * @tags LifeSkillsCertification
     * @name GetLifeSkillsCertificationSets
     * @request GET:/api/LifeSkillsCertifications/sets
     */
    getLifeSkillsCertificationSets: (params: RequestParams = {}) =>
      this.request<LifeSkillsCertificationSet[], any>({
        path: `/api/LifeSkillsCertifications/sets`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsCertification
     * @name GetLifeSkillsCertifications
     * @request GET:/api/LifeSkillsCertifications/{examinerId}
     */
    getLifeSkillsCertifications: (
      { examinerId, ...query }: GetLifeSkillsCertificationsParams,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfLifeSkillsCertificationInformation, any>({
        path: `/api/LifeSkillsCertifications/${examinerId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsCertification
     * @name GetDetails
     * @request GET:/api/LifeSkillsCertifications/details/{certificationId}
     */
    getDetails: ({ certificationId }: GetDetailsParams, params: RequestParams = {}) =>
      this.request<LifeSkillsCertificationDetails, any>({
        path: `/api/LifeSkillsCertifications/details/${certificationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsCertification
     * @name SaveLifeSkillsCertification
     * @request POST:/api/LifeSkillsCertifications/save
     */
    saveLifeSkillsCertification: (data: LifeSkillsCertification, params: RequestParams = {}) =>
      this.request<LifeSkillsCertification, any>({
        path: `/api/LifeSkillsCertifications/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsCertification
     * @name DeleteLifeSkillsCertification
     * @request DELETE:/api/LifeSkillsCertifications/delete
     */
    deleteLifeSkillsCertification: (
      query: DeleteLifeSkillsCertificationParams = {},
      params: RequestParams = {}
    ) =>
      this.request<LifeSkillsCertification, any>({
        path: `/api/LifeSkillsCertifications/delete`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsCertification
     * @name GetNextLifeSkillsRecertificationDates
     * @request GET:/api/LifeSkillsCertifications/NextLifeSkillsRecertificationDates/{examinerId}
     */
    getNextLifeSkillsRecertificationDates: (
      { examinerId }: GetNextLifeSkillsRecertificationDatesParams,
      params: RequestParams = {}
    ) =>
      this.request<LifeSkillsRecertificationDate[], any>({
        path: `/api/LifeSkillsCertifications/NextLifeSkillsRecertificationDates/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsCertification
     * @name GetLastPassedCertificationBasicData
     * @request GET:/api/LifeSkillsCertifications/examiner/{examinerId}/lastPassedCertificationDate
     */
    getLastPassedCertificationBasicData: (
      { examinerId }: GetLastPassedCertificationBasicDataParams,
      params: RequestParams = {}
    ) =>
      this.request<LifeSkillCertificationBasicDataOfInteger[], any>({
        path: `/api/LifeSkillsCertifications/examiner/${examinerId}/lastPassedCertificationDate`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  lifeSkillsLevel = {
    /**
     * No description
     *
     * @tags LifeSkillsLevel
     * @name GetLevelsForExaminer
     * @request GET:/api/LifeSkillsLevels/levels/{examinerId}
     */
    getLevelsForExaminer: (
      { examinerId, ...query }: GetLevelsForExaminerParams,
      params: RequestParams = {}
    ) =>
      this.request<LifeSkillsLevel[], any>({
        path: `/api/LifeSkillsLevels/levels/${examinerId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  lifeSkillsMonitoring = {
    /**
     * No description
     *
     * @tags LifeSkillsMonitoring
     * @name GetExaminerLifeSkillsMonitorings
     * @request GET:/api/LifeSkillsMonitorings/examiner/{examinerId}
     */
    getExaminerLifeSkillsMonitorings: (
      { examinerId, ...query }: GetExaminerLifeSkillsMonitoringsParams,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfLifeSkillsMonitoring, any>({
        path: `/api/LifeSkillsMonitorings/examiner/${examinerId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsMonitoring
     * @name GetNextLifeSkillsMonitoringDates
     * @request GET:/api/LifeSkillsMonitorings/NextLifeSkillsMonitoringDates/{examinerId}
     */
    getNextLifeSkillsMonitoringDates: (
      { examinerId }: GetNextLifeSkillsMonitoringDatesParams,
      params: RequestParams = {}
    ) =>
      this.request<LifeSkillsMonitoringDate[], any>({
        path: `/api/LifeSkillsMonitorings/NextLifeSkillsMonitoringDates/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsMonitoring
     * @name Save
     * @request POST:/api/LifeSkillsMonitorings
     */
    save: (data: LifeSkillsMonitoringDetails, params: RequestParams = {}) =>
      this.request<LifeSkillsMonitoringDetails, any>({
        path: `/api/LifeSkillsMonitorings`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsMonitoring
     * @name Get
     * @request GET:/api/LifeSkillsMonitorings/{id}
     */
    get: ({ id }: GetParams7, params: RequestParams = {}) =>
      this.request<LifeSkillsMonitoringDetails, any>({
        path: `/api/LifeSkillsMonitorings/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsMonitoring
     * @name Delete
     * @request DELETE:/api/LifeSkillsMonitorings/{id}
     */
    delete: ({ id }: DeleteParams2, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/LifeSkillsMonitorings/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsMonitoring
     * @name CanAddLifeSkillsMonitoring
     * @request GET:/api/LifeSkillsMonitorings/examiner/{examinerId}/CanAddLifeSkillsMonitoring
     */
    canAddLifeSkillsMonitoring: (
      { examinerId }: CanAddLifeSkillsMonitoringParams,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/LifeSkillsMonitorings/examiner/${examinerId}/CanAddLifeSkillsMonitoring`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsMonitoring
     * @name Restore
     * @request POST:/api/LifeSkillsMonitorings/{id}/Restore
     */
    restore: ({ id }: RestoreParams2, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/LifeSkillsMonitorings/${id}/Restore`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LifeSkillsMonitoring
     * @name GetDeletedDetails
     * @request GET:/api/LifeSkillsMonitorings/{id}/delete/details
     */
    getDeletedDetails: ({ id }: GetDeletedDetailsParams, params: RequestParams = {}) =>
      this.request<DeletedDetails, any>({
        path: `/api/LifeSkillsMonitorings/${id}/delete/details`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  monitoringsDueReport = {
    /**
     * No description
     *
     * @tags MonitoringsDueReport
     * @name GetMonitoringDueReport
     * @request GET:/api/reports/monitorings-due
     */
    getMonitoringDueReport: (
      query: GetMonitoringDueReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfMonitoringDueReportResponse, any>({
        path: `/api/reports/monitorings-due`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitoringsDueReport
     * @name GetMonitoringDuePdfReport
     * @request GET:/api/reports/monitorings-due/pdf
     */
    getMonitoringDuePdfReport: (
      query: GetMonitoringDuePdfReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/monitorings-due/pdf`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonitoringsDueReport
     * @name GetMonitoringDueExcelReport
     * @request GET:/api/reports/monitorings-due/excel
     */
    getMonitoringDueExcelReport: (
      query: GetMonitoringDueExcelReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/monitorings-due/excel`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  odpAssessment = {
    /**
     * No description
     *
     * @tags OdpAssessment
     * @name GetAll
     * @request GET:/api/examiners/{examinerId}/odp-assessments
     */
    getAll: ({ examinerId, ...query }: GetAllParams, params: RequestParams = {}) =>
      this.request<PagedResultOfOdpAssessmentListResult, any>({
        path: `/api/examiners/${examinerId}/odp-assessments`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpAssessment
     * @name Create
     * @request POST:/api/examiners/{examinerId}/odp-assessments
     */
    create: (
      { examinerId }: CreateParams1,
      data: CreateOdpAssessmentRequest,
      params: RequestParams = {}
    ) =>
      this.request<OdpAssessmentDetailsResult, Result>({
        path: `/api/examiners/${examinerId}/odp-assessments`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpAssessment
     * @name Get
     * @request GET:/api/examiners/{examinerId}/odp-assessments/{id}
     */
    get: ({ examinerId, id }: GetParams9, params: RequestParams = {}) =>
      this.request<OdpAssessmentDetailsResult, Result>({
        path: `/api/examiners/${examinerId}/odp-assessments/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpAssessment
     * @name Update
     * @request PUT:/api/examiners/{examinerId}/odp-assessments/{id}
     */
    update: (
      { id, examinerId }: UpdateParams2,
      data: UpdateOdpAssessmentRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, Result>({
        path: `/api/examiners/${examinerId}/odp-assessments/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpAssessment
     * @name Delete
     * @request DELETE:/api/examiners/{examinerId}/odp-assessments/{id}
     */
    delete: ({ id, examinerId }: DeleteParams4, params: RequestParams = {}) =>
      this.request<void, Result>({
        path: `/api/examiners/${examinerId}/odp-assessments/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpAssessment
     * @name HasCompleted
     * @request GET:/api/examiners/{examinerId}/odp-assessments/has-completed
     */
    hasCompleted: ({ examinerId }: HasCompletedParams, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/examiners/${examinerId}/odp-assessments/has-completed`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpAssessment
     * @name HasRequiredTraining
     * @request GET:/api/examiners/{examinerId}/odp-assessments/has-required-training
     */
    hasRequiredTraining: ({ examinerId }: HasRequiredTrainingParams, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/examiners/${examinerId}/odp-assessments/has-required-training`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  odpAssessmentReport = {
    /**
     * No description
     *
     * @tags OdpAssessmentReport
     * @name GetOdpAssessmentReport
     * @request GET:/api/reports/odp-assessment
     */
    getOdpAssessmentReport: (
      query: GetOdpAssessmentReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfOdpAssessmentReportRecordDto, any>({
        path: `/api/reports/odp-assessment`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpAssessmentReport
     * @name GetOdpAssessmentExcelReport
     * @request GET:/api/reports/odp-assessment/excel
     */
    getOdpAssessmentExcelReport: (
      query: GetOdpAssessmentExcelReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/odp-assessment/excel`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpAssessmentReport
     * @name GetOdpAssessmentPdfReport
     * @request GET:/api/reports/odp-assessment/pdf
     */
    getOdpAssessmentPdfReport: (
      query: GetOdpAssessmentPdfReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/odp-assessment/pdf`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  odpMonitoring = {
    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name GetAll
     * @request GET:/api/examiners/{examinerId}/odp-monitorings
     */
    getAll: ({ examinerId }: GetAllParams2, params: RequestParams = {}) =>
      this.request<OdpMonitoringListResult[], any>({
        path: `/api/examiners/${examinerId}/odp-monitorings`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name Create
     * @request POST:/api/examiners/{examinerId}/odp-monitorings
     */
    create: (
      { examinerId }: CreateParams3,
      data: CreateOdpMonitoringRequest,
      params: RequestParams = {}
    ) =>
      this.request<OdpMonitoringDetailsResult, Result>({
        path: `/api/examiners/${examinerId}/odp-monitorings`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name Delete
     * @request DELETE:/api/examiners/{examinerId}/odp-monitorings
     */
    delete: ({ examinerId, ...query }: DeleteParams6, params: RequestParams = {}) =>
      this.request<void, Result>({
        path: `/api/examiners/${examinerId}/odp-monitorings`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name Get
     * @request GET:/api/examiners/{examinerId}/odp-monitorings/{id}
     */
    get: ({ examinerId, id }: GetParams11, params: RequestParams = {}) =>
      this.request<OdpMonitoringDetailsResult, Result>({
        path: `/api/examiners/${examinerId}/odp-monitorings/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name Update
     * @request PUT:/api/examiners/{examinerId}/odp-monitorings/{id}
     */
    update: (
      { examinerId, id }: UpdateParams4,
      data: UpdateOdpMonitoringRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, Result>({
        path: `/api/examiners/${examinerId}/odp-monitorings/${id}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name Restore
     * @request PUT:/api/examiners/{examinerId}/odp-monitorings/{id}/restore
     */
    restore: ({ examinerId, id }: RestoreParams4, params: RequestParams = {}) =>
      this.request<void, Result>({
        path: `/api/examiners/${examinerId}/odp-monitorings/${id}/restore`,
        method: 'PUT',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name CalculateNextStage
     * @request GET:/api/examiners/{examinerId}/odp-monitorings/next-stage
     */
    calculateNextStage: (
      { examinerId, ...query }: CalculateNextStageParams,
      params: RequestParams = {}
    ) =>
      this.request<NextOdpMonitoringStageResult, any>({
        path: `/api/examiners/${examinerId}/odp-monitorings/next-stage`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name CalculateNextMonitoringDate
     * @request GET:/api/examiners/odp-monitorings/next-monitoring-date/calculate
     */
    calculateNextMonitoringDate: (
      query: CalculateNextMonitoringDateParams = {},
      params: RequestParams = {}
    ) =>
      this.request<OdpMonitoringNextDateOptionResult[], any>({
        path: `/api/examiners/odp-monitorings/next-monitoring-date/calculate`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name GetNextMonitoringDate
     * @request GET:/api/examiners/{examinerId}/odp-monitorings/next-monitoring-date
     */
    getNextMonitoringDate: (
      { examinerId }: GetNextMonitoringDateParams,
      params: RequestParams = {}
    ) =>
      this.request<NextOdpMonitoringDateResult, any>({
        path: `/api/examiners/${examinerId}/odp-monitorings/next-monitoring-date`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name CanEditCustomNextMonitoringDate
     * @request GET:/api/examiners/{examinerId}/odp-monitorings/next-monitoring-date/can-edit
     */
    canEditCustomNextMonitoringDate: (
      { examinerId, ...query }: CanEditCustomNextMonitoringDateParams,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/examiners/${examinerId}/odp-monitorings/next-monitoring-date/can-edit`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name AddFollowUp
     * @request POST:/api/examiners/{examinerId}/odp-monitorings/{id}/follow-up
     */
    addFollowUp: (
      { examinerId, id }: AddFollowUpParams,
      data: AddOdpMonitoringFollowUpRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, Result>({
        path: `/api/examiners/${examinerId}/odp-monitorings/${id}/follow-up`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name UpdateFollowUp
     * @request PUT:/api/examiners/{examinerId}/odp-monitorings/{id}/follow-up
     */
    updateFollowUp: (
      { examinerId, id }: UpdateFollowUpParams,
      data: UpdateOdpMonitoringFollowUpRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, Result>({
        path: `/api/examiners/${examinerId}/odp-monitorings/${id}/follow-up`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name RemoveFollowUp
     * @request DELETE:/api/examiners/{examinerId}/odp-monitorings/{id}/follow-up
     */
    removeFollowUp: ({ examinerId, id }: RemoveFollowUpParams, params: RequestParams = {}) =>
      this.request<void, Result>({
        path: `/api/examiners/${examinerId}/odp-monitorings/${id}/follow-up`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoring
     * @name CanAddFollowUp
     * @request GET:/api/examiners/{examinerId}/odp-monitorings/{id}/can-add-follow-up
     */
    canAddFollowUp: ({ examinerId, id }: CanAddFollowUpParams, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/examiners/${examinerId}/odp-monitorings/${id}/can-add-follow-up`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  odpMonitoringReport = {
    /**
     * No description
     *
     * @tags OdpMonitoringReport
     * @name GetOdpMonitoringReport
     * @request GET:/api/reports/odp-monitoring
     */
    getOdpMonitoringReport: (
      query: GetOdpMonitoringReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfOdpMonitoringReportRecordDto, any>({
        path: `/api/reports/odp-monitoring`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoringReport
     * @name GetOdpMonitoringExcelReport
     * @request GET:/api/reports/odp-monitoring/excel
     */
    getOdpMonitoringExcelReport: (
      query: GetOdpMonitoringExcelReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/odp-monitoring/excel`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OdpMonitoringReport
     * @name GetOdpMonitoringPdfReport
     * @request GET:/api/reports/odp-monitoring/pdf
     */
    getOdpMonitoringPdfReport: (
      query: GetOdpMonitoringPdfReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/odp-monitoring/pdf`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  onlineSpeakingMonitoring = {
    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name Create
     * @request POST:/api/online-speaking-monitorings
     */
    create: (data: CreateOnlineSpeakingMonitoringRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/online-speaking-monitorings`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name Update
     * @request POST:/api/online-speaking-monitorings/{id}
     */
    update: (
      { id }: UpdateParams6,
      data: UpdateOnlineSpeakingMonitoringRequest,
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/api/online-speaking-monitorings/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name GetDetails
     * @request GET:/api/online-speaking-monitorings/{id}
     */
    getDetails: ({ id }: GetDetailsParams2, params: RequestParams = {}) =>
      this.request<OnlineSpeakingMonitoringDetailsDto, any>({
        path: `/api/online-speaking-monitorings/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name Archive
     * @request POST:/api/online-speaking-monitorings/archive
     */
    archive: (data: ArchiveOnlineSpeakingMonitoringRequest, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/online-speaking-monitorings/archive`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name Get
     * @request GET:/api/online-speaking-monitorings/examiner/{examinerId}
     */
    get: ({ examinerId }: GetParams13, params: RequestParams = {}) =>
      this.request<OnlineSpeakingMonitoringsResponse, any>({
        path: `/api/online-speaking-monitorings/examiner/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name UpdateFollowUp
     * @request POST:/api/online-speaking-monitorings/{id}/follow-up
     */
    updateFollowUp: (
      { id }: UpdateFollowUpParams2,
      data: UpdateOnlineSpeakingMonitoringFollowUpRequest,
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/online-speaking-monitorings/${id}/follow-up`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name Delete
     * @request POST:/api/online-speaking-monitorings/{id}/delete
     */
    delete: ({ id }: DeleteParams8, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/online-speaking-monitorings/${id}/delete`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name BulkDelete
     * @request POST:/api/online-speaking-monitorings/delete
     */
    bulkDelete: (data: BulkDeleteOnlineSpeakingMonitoringRequest, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/online-speaking-monitorings/delete`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name RestoreArchived
     * @request POST:/api/online-speaking-monitorings/{id}/restore/archived
     */
    restoreArchived: ({ id }: RestoreArchivedParams, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/online-speaking-monitorings/${id}/restore/archived`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name RestoreDeleted
     * @request POST:/api/online-speaking-monitorings/{id}/restore/deleted
     */
    restoreDeleted: ({ id }: RestoreDeletedParams, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/online-speaking-monitorings/${id}/restore/deleted`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name GetAvailableOnlineSpeakingMonitoringResultsForExistingMonitoring
     * @request GET:/api/online-speaking-monitorings/{id}/results-for-existing-monitoring
     */
    getAvailableOnlineSpeakingMonitoringResultsForExistingMonitoring: (
      { id, ...query }: GetAvailableOnlineSpeakingMonitoringResultsForExistingMonitoringParams,
      params: RequestParams = {}
    ) =>
      this.request<OnlineSpeakingMonitoringAvailableResultsForExistingMonitoringResponse, any>({
        path: `/api/online-speaking-monitorings/${id}/results-for-existing-monitoring`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSpeakingMonitoring
     * @name GetAvailableOnlineSpeakingMonitoringResultsForNewMonitoring
     * @request GET:/api/online-speaking-monitorings/examiner/{examinerId}/results
     */
    getAvailableOnlineSpeakingMonitoringResultsForNewMonitoring: (
      { examinerId, ...query }: GetAvailableOnlineSpeakingMonitoringResultsForNewMonitoringParams,
      params: RequestParams = {}
    ) =>
      this.request<OnlineSpeakingMonitoringAvailableResultsForNewMonitoringResponse, any>({
        path: `/api/online-speaking-monitorings/examiner/${examinerId}/results`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  osmMonitoring = {
    /**
     * No description
     *
     * @tags OsmMonitoring
     * @name CreateOsmMonitoring
     * @request POST:/api/osm-monitorings
     */
    createOsmMonitoring: (data: CreateOsmMonitoringRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/osm-monitorings`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmMonitoring
     * @name UpdateOsmMonitoring
     * @request POST:/api/osm-monitorings/{id}
     */
    updateOsmMonitoring: (
      { id }: UpdateOsmMonitoringParams,
      data: UpdateOsmMonitoringRequest,
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/api/osm-monitorings/${id}`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmMonitoring
     * @name GetOsmMonitoringDetails
     * @request GET:/api/osm-monitorings/{id}
     */
    getOsmMonitoringDetails: ({ id }: GetOsmMonitoringDetailsParams, params: RequestParams = {}) =>
      this.request<OsmMonitoringDetailsDto, any>({
        path: `/api/osm-monitorings/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmMonitoring
     * @name ArchiveOsmMonitoring
     * @request POST:/api/osm-monitorings/archive
     */
    archiveOsmMonitoring: (data: ArchiveOsmMonitoringRequest, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/osm-monitorings/archive`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmMonitoring
     * @name GetOsmMonitorings
     * @request GET:/api/osm-monitorings/examiner/{examinerId}
     */
    getOsmMonitorings: ({ examinerId }: GetOsmMonitoringsParams, params: RequestParams = {}) =>
      this.request<OsmMonitoringsResponse, any>({
        path: `/api/osm-monitorings/examiner/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmMonitoring
     * @name UpdateOsmMonitoringFollowUp
     * @request POST:/api/osm-monitorings/{id}/follow-up
     */
    updateOsmMonitoringFollowUp: (
      { id }: UpdateOsmMonitoringFollowUpParams,
      data: UpdateOsmMonitoringFollowUpRequest,
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/osm-monitorings/${id}/follow-up`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmMonitoring
     * @name DeleteOsmMonitoring
     * @request POST:/api/osm-monitorings/{id}/delete
     */
    deleteOsmMonitoring: ({ id }: DeleteOsmMonitoringParams, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/osm-monitorings/${id}/delete`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmMonitoring
     * @name BulkDelete
     * @request POST:/api/osm-monitorings/delete
     */
    bulkDelete: (data: BulkDeleteOsmMonitoringRequest, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/osm-monitorings/delete`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmMonitoring
     * @name RestoreArchived
     * @request POST:/api/osm-monitorings/{id}/restore/archived
     */
    restoreArchived: ({ id }: RestoreArchivedParams2, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/osm-monitorings/${id}/restore/archived`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmMonitoring
     * @name RestoreDeleted
     * @request POST:/api/osm-monitorings/{id}/restore/deleted
     */
    restoreDeleted: ({ id }: RestoreDeletedParams2, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/osm-monitorings/${id}/restore/deleted`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmMonitoring
     * @name GetAvailableOsmMonitoringResults
     * @request GET:/api/osm-monitorings/{id}/results
     */
    getAvailableOsmMonitoringResults: (
      { id }: GetAvailableOsmMonitoringResultsParams,
      params: RequestParams = {}
    ) =>
      this.request<OsmMonitoringAvailableResultsForExistingMonitoringResponse, any>({
        path: `/api/osm-monitorings/${id}/results`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  osmMonitoringType = {
    /**
     * No description
     *
     * @tags OsmMonitoringType
     * @name GetOsmMonitoringTypes
     * @request GET:/api/osm-monitoring-types/examiner/{examinerId}
     */
    getOsmMonitoringTypes: (
      { examinerId }: GetOsmMonitoringTypesParams,
      params: RequestParams = {}
    ) =>
      this.request<GetOsmMonitoringTypesResponse, any>({
        path: `/api/osm-monitoring-types/examiner/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmMonitoringType
     * @name GetAvailableOsmMonitoringResults
     * @request GET:/api/osm-monitoring-types/{type}/examiner/{examinerId}/results
     */
    getAvailableOsmMonitoringResults: (
      { type, examinerId, ...query }: GetAvailableOsmMonitoringResultsParams2,
      params: RequestParams = {}
    ) =>
      this.request<OsmMonitoringAvailableResultsForTypeResponse, any>({
        path: `/api/osm-monitoring-types/${type}/examiner/${examinerId}/results`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  osmWritingMonitoringReport = {
    /**
     * No description
     *
     * @tags OsmWritingMonitoringReport
     * @name GetOsmWritingMonitoring
     * @request GET:/api/reports/oms-writing-monitoring
     */
    getOsmWritingMonitoring: (
      query: GetOsmWritingMonitoringParams = {},
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfOsmWritingMonitoringReportResponse, any>({
        path: `/api/reports/oms-writing-monitoring`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmWritingMonitoringReport
     * @name GetOsmWritingPdfMonitoring
     * @request GET:/api/reports/oms-writing-monitoring/pdf
     */
    getOsmWritingPdfMonitoring: (
      query: GetOsmWritingPdfMonitoringParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/oms-writing-monitoring/pdf`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OsmWritingMonitoringReport
     * @name GetOsmWritingExcelMonitoring
     * @request GET:/api/reports/oms-writing-monitoring/excel
     */
    getOsmWritingExcelMonitoring: (
      query: GetOsmWritingExcelMonitoringParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/oms-writing-monitoring/excel`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  permission = {
    /**
     * No description
     *
     * @tags Permission
     * @name GetPermissions
     * @request GET:/api/permissions
     */
    getPermissions: (params: RequestParams = {}) =>
      this.request<Permission[], any>({
        path: `/api/permissions`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  region = {
    /**
     * No description
     *
     * @tags Region
     * @name GetRegions
     * @request GET:/api/regions
     */
    getRegions: (params: RequestParams = {}) =>
      this.request<Region[], any>({
        path: `/api/regions`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  role = {
    /**
     * No description
     *
     * @tags Role
     * @name GetAll
     * @request GET:/api/roles/all
     */
    getAll: (params: RequestParams = {}) =>
      this.request<Role2[], any>({
        path: `/api/roles/all`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  speakingCertification = {
    /**
     * No description
     *
     * @tags SpeakingCertification
     * @name GetDetails
     * @request GET:/api/examiner/{examinerId}/speaking-certifications/{id}
     */
    getDetails: ({ examinerId, id }: GetDetailsParams4, params: RequestParams = {}) =>
      this.request<SpeakingCertificationDetailsResult, any>({
        path: `/api/examiner/${examinerId}/speaking-certifications/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingCertification
     * @name Delete
     * @request DELETE:/api/examiner/{examinerId}/speaking-certifications/{id}
     */
    delete: ({ id, examinerId }: DeleteParams10, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/examiner/${examinerId}/speaking-certifications/${id}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingCertification
     * @name CheckIfCertificationIsDeletable
     * @request GET:/api/examiner/{examinerId}/speaking-certifications/{certificationId}/deletable
     */
    checkIfCertificationIsDeletable: (
      { examinerId, certificationId }: CheckIfCertificationIsDeletableParams,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/examiner/${examinerId}/speaking-certifications/${certificationId}/deletable`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingCertification
     * @name GetExaminerSpeakingCertifications
     * @request GET:/api/examiner/{examinerId}/speaking-certifications
     */
    getExaminerSpeakingCertifications: (
      { examinerId, ...query }: GetExaminerSpeakingCertificationsParams,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfSpeakingCertificationListItemResult, any>({
        path: `/api/examiner/${examinerId}/speaking-certifications`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingCertification
     * @name SaveCertification
     * @request POST:/api/examiner/{examinerId}/speaking-certifications
     */
    saveCertification: (
      { examinerId }: SaveCertificationParams,
      data: SpeakingCertificationCalculationDetails,
      params: RequestParams = {}
    ) =>
      this.request<void, Result>({
        path: `/api/examiner/${examinerId}/speaking-certifications`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingCertification
     * @name DoCalculation
     * @request POST:/api/examiner/{examinerId}/speaking-certifications/calculate
     */
    doCalculation: (
      { examinerId }: DoCalculationParams,
      data: SpeakingCertificationCalculation,
      params: RequestParams = {}
    ) =>
      this.request<SpeakingCertificationCalculationResult, any>({
        path: `/api/examiner/${examinerId}/speaking-certifications/calculate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingCertification
     * @name GetNextCertificationsDate
     * @request GET:/api/examiner/{examinerId}/speaking-certifications/next-certification-date
     */
    getNextCertificationsDate: (
      { examinerId }: GetNextCertificationsDateParams,
      params: RequestParams = {}
    ) =>
      this.request<string | null, any>({
        path: `/api/examiner/${examinerId}/speaking-certifications/next-certification-date`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingCertification
     * @name IsNumberOfAttemptsExceeded
     * @request GET:/api/examiner/{examinerId}/speaking-certifications/is-number-of-attempts-exceeded/{setId}
     */
    isNumberOfAttemptsExceeded: (
      { examinerId, setId }: IsNumberOfAttemptsExceededParams,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/examiner/${examinerId}/speaking-certifications/is-number-of-attempts-exceeded/${setId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingCertification
     * @name IsGapBetweenAttemptsExceeded
     * @request GET:/api/examiner/{examinerId}/speaking-certifications/is-gap-between-attempts-exceeded/{setId}
     */
    isGapBetweenAttemptsExceeded: (
      { examinerId, setId, ...query }: IsGapBetweenAttemptsExceededParams,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/examiner/${examinerId}/speaking-certifications/is-gap-between-attempts-exceeded/${setId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingCertification
     * @name GetLastPassedCertificationBasicData
     * @request GET:/api/examiner/{examinerId}/speaking-certifications/last-passed-certification-date
     */
    getLastPassedCertificationBasicData: (
      { examinerId }: GetLastPassedCertificationBasicDataParams2,
      params: RequestParams = {}
    ) =>
      this.request<CertificationBasicDataResult, any>({
        path: `/api/examiner/${examinerId}/speaking-certifications/last-passed-certification-date`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  speakingCertificationRate = {
    /**
     * No description
     *
     * @tags SpeakingCertificationRate
     * @name GetExaminerSpeakingCertifications
     * @request GET:/api/SpeakingCertificationRates/{certificationId}
     */
    getExaminerSpeakingCertifications: (
      { certificationId }: GetExaminerSpeakingCertificationsParams2,
      params: RequestParams = {}
    ) =>
      this.request<SpeakingCertificationRate[], any>({
        path: `/api/SpeakingCertificationRates/${certificationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  speakingCertificationSet = {
    /**
     * No description
     *
     * @tags SpeakingCertificationSet
     * @name GetExaminerSpeakingCertifications
     * @request GET:/api/SpeakingCertificationSets/availableForExaminer/{examinerId}
     */
    getExaminerSpeakingCertifications: (
      { examinerId }: GetExaminerSpeakingCertificationsParams4,
      params: RequestParams = {}
    ) =>
      this.request<AvailableSpeakingCertificationSet[], any>({
        path: `/api/SpeakingCertificationSets/availableForExaminer/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  speakingMonitoring = {
    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name GetNextMonitoringDate
     * @request GET:/api/examiner/{examinerId}/next-monitoring-date
     */
    getNextMonitoringDate: (
      { examinerId }: GetNextMonitoringDateParams2,
      params: RequestParams = {}
    ) =>
      this.request<MonitoringDate, any>({
        path: `/api/examiner/${examinerId}/next-monitoring-date`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name GetCalculatedNextMonitoringDate
     * @request POST:/api/SpeakingMonitorings/nextMonitoringDate/calculate
     */
    getCalculatedNextMonitoringDate: (
      data: SpeakingMonitoringDetails,
      params: RequestParams = {}
    ) =>
      this.request<SpeakingMonitoringNextDateOptions[], any>({
        path: `/api/SpeakingMonitorings/nextMonitoringDate/calculate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name Save
     * @request POST:/api/examiner/{examinerId}/speaking-monitorings
     */
    save: (
      { examinerId }: SaveParams3,
      data: SaveSpeakingMonitoringRequest,
      params: RequestParams = {}
    ) =>
      this.request<number, any>({
        path: `/api/examiner/${examinerId}/speaking-monitorings`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name GetExaminerSpeakingMonitorings
     * @request GET:/api/examiner/{examinerId}/speaking-monitorings
     */
    getExaminerSpeakingMonitorings: (
      { examinerId, ...query }: GetExaminerSpeakingMonitoringsParams,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfSpeakingMonitoring, any>({
        path: `/api/examiner/${examinerId}/speaking-monitorings`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name Get
     * @request GET:/api/examiner/{examinerId}/speaking-monitorings/{speakingMonitoringId}
     */
    get: ({ examinerId, speakingMonitoringId }: GetParams15, params: RequestParams = {}) =>
      this.request<SpeakingMonitoringDetails, any>({
        path: `/api/examiner/${examinerId}/speaking-monitorings/${speakingMonitoringId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name Delete
     * @request DELETE:/api/examiner/{examinerId}/speaking-monitorings/{speakingMonitoringId}
     */
    delete: ({ examinerId, speakingMonitoringId }: DeleteParams12, params: RequestParams = {}) =>
      this.request<void, Result>({
        path: `/api/examiner/${examinerId}/speaking-monitorings/${speakingMonitoringId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name Restore
     * @request POST:/api/examiner/{examinerId}/speaking-monitorings/{speakingMonitoringId}/restore
     */
    restore: ({ examinerId, speakingMonitoringId }: RestoreParams6, params: RequestParams = {}) =>
      this.request<void, Result>({
        path: `/api/examiner/${examinerId}/speaking-monitorings/${speakingMonitoringId}/restore`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name CanAddSpeakingMonitoring
     * @request GET:/api/examiner/{examinerId}/can-add-speaking-monitoring
     */
    canAddSpeakingMonitoring: (
      { examinerId }: CanAddSpeakingMonitoringParams,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/examiner/${examinerId}/can-add-speaking-monitoring`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name GetCustomNextMonitoringDateOptions
     * @request GET:/api/SpeakingMonitorings/examiner/custom-next-monitoring-date-options
     */
    getCustomNextMonitoringDateOptions: (
      query: GetCustomNextMonitoringDateOptionsParams = {},
      params: RequestParams = {}
    ) =>
      this.request<CustomNextMonitoringDateOptions, any>({
        path: `/api/SpeakingMonitorings/examiner/custom-next-monitoring-date-options`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name GetCalculatedMonitoringStage
     * @request GET:/api/examiner/{examinerId}/speaking-monitorings/calculated-stage
     */
    getCalculatedMonitoringStage: (
      { examinerId, ...query }: GetCalculatedMonitoringStageParams,
      params: RequestParams = {}
    ) =>
      this.request<SpeakingMonitoringStage, any>({
        path: `/api/examiner/${examinerId}/speaking-monitorings/calculated-stage`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name GetFollowUp
     * @request GET:/api/examiner/{examinerId}/speaking-monitorings/{speakingMonitoringId}/followup
     */
    getFollowUp: (
      { examinerId, speakingMonitoringId }: GetFollowUpParams,
      params: RequestParams = {}
    ) =>
      this.request<SpeakingMonitoringFollowUpResult, any>({
        path: `/api/examiner/${examinerId}/speaking-monitorings/${speakingMonitoringId}/followup`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name CreateFollowUp
     * @request POST:/api/examiner/{examinerId}/speaking-monitorings/{speakingMonitoringId}/followup
     */
    createFollowUp: (
      { examinerId, speakingMonitoringId }: CreateFollowUpParams,
      data: SaveSpeakingMonitoringFollowUpRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, Result>({
        path: `/api/examiner/${examinerId}/speaking-monitorings/${speakingMonitoringId}/followup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name UpdateFollowUp
     * @request PUT:/api/examiner/{examinerId}/speaking-monitorings/{speakingMonitoringId}/followup
     */
    updateFollowUp: (
      { examinerId, speakingMonitoringId }: UpdateFollowUpParams4,
      data: SaveSpeakingMonitoringFollowUpRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, Result>({
        path: `/api/examiner/${examinerId}/speaking-monitorings/${speakingMonitoringId}/followup`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name DeleteFollowUp
     * @request DELETE:/api/examiner/{examinerId}/speaking-monitorings/{speakingMonitoringId}/followup
     */
    deleteFollowUp: (
      { examinerId, speakingMonitoringId }: DeleteFollowUpParams1,
      params: RequestParams = {}
    ) =>
      this.request<void, Result>({
        path: `/api/examiner/${examinerId}/speaking-monitorings/${speakingMonitoringId}/followup`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoring
     * @name CanAddFollowUp
     * @request GET:/api/examiner/{examinerId}/speaking-monitorings/{speakingMonitoringId}/followup/availability
     */
    canAddFollowUp: (
      { examinerId, speakingMonitoringId }: CanAddFollowUpParams2,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/examiner/${examinerId}/speaking-monitorings/${speakingMonitoringId}/followup/availability`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  speakingMonitoringResult = {
    /**
     * No description
     *
     * @tags SpeakingMonitoringResult
     * @name GetProcedureResults
     * @request GET:/api/SpeakingMonitoringResults/Procedures
     */
    getProcedureResults: (params: RequestParams = {}) =>
      this.request<SpeakingMonitoringResult[], any>({
        path: `/api/SpeakingMonitoringResults/Procedures`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoringResult
     * @name GetRatingResults
     * @request GET:/api/SpeakingMonitoringResults/Ratings
     */
    getRatingResults: (params: RequestParams = {}) =>
      this.request<SpeakingMonitoringResult[], any>({
        path: `/api/SpeakingMonitoringResults/Ratings`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoringResult
     * @name GetFinalRatingResults
     * @request GET:/api/SpeakingMonitoringResults/Final
     */
    getFinalRatingResults: (params: RequestParams = {}) =>
      this.request<SpeakingMonitoringResult[], any>({
        path: `/api/SpeakingMonitoringResults/Final`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakingMonitoringResult
     * @name CalculateFinalResult
     * @request POST:/api/SpeakingMonitoringResults/FinalResult
     */
    calculateFinalResult: (
      data: SpeakingMonitoringCalculationRequest,
      params: RequestParams = {}
    ) =>
      this.request<SpeakingMonitoringResult, any>({
        path: `/api/SpeakingMonitoringResults/FinalResult`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  timeZone = {
    /**
     * No description
     *
     * @tags TimeZone
     * @name GetAll
     * @request GET:/api/time-zones/all
     */
    getAll: (params: RequestParams = {}) =>
      this.request<TimeZoneSimple[], any>({
        path: `/api/time-zones/all`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  trainingAndStandardisationReport = {
    /**
     * No description
     *
     * @tags TrainingAndStandardisationReport
     * @name GetTrainingsAndStandardisations
     * @request GET:/api/reports/training-and-standardisation
     */
    getTrainingsAndStandardisations: (
      query: GetTrainingsAndStandardisationsParams = {},
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfTrainingAndStandardisationReportRecordDto, any>({
        path: `/api/reports/training-and-standardisation`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingAndStandardisationReport
     * @name GetTrainingsAndStandardisationsExcelReport
     * @request GET:/api/reports/training-and-standardisation/excel
     */
    getTrainingsAndStandardisationsExcelReport: (
      query: GetTrainingsAndStandardisationsExcelReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/training-and-standardisation/excel`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags TrainingAndStandardisationReport
     * @name GetTrainingsAndStandardisationsPdfReport
     * @request GET:/api/reports/training-and-standardisation/pdf
     */
    getTrainingsAndStandardisationsPdfReport: (
      query: GetTrainingsAndStandardisationsPdfReportParams = {},
      params: RequestParams = {}
    ) =>
      this.request<Blob, any>({
        path: `/api/reports/training-and-standardisation/pdf`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  training = {
    /**
     * No description
     *
     * @tags Training
     * @name GetAll
     * @request GET:/api/trainings
     */
    getAll: (params: RequestParams = {}) =>
      this.request<Training[], any>({
        path: `/api/trainings`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags User
     * @name GetUsers
     * @request GET:/api/users
     */
    getUsers: (query: GetUsersParams = {}, params: RequestParams = {}) =>
      this.request<PagedResultOfUser, any>({
        path: `/api/users`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUserDetails
     * @request GET:/api/users/{userId}
     */
    getUserDetails: ({ userId }: GetUserDetailsParams, params: RequestParams = {}) =>
      this.request<User, any>({
        path: `/api/users/${userId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name SaveUserDetails
     * @request POST:/api/users/details/save
     */
    saveUserDetails: (data: User, params: RequestParams = {}) =>
      this.request<User, any>({
        path: `/api/users/details/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name RevokeAccess
     * @request POST:/api/users/revokeAccess
     */
    revokeAccess: (query: RevokeAccessParams = {}, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/users/revokeAccess`,
        method: 'POST',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUserByEmail
     * @request GET:/api/users/user/byEmail
     */
    getUserByEmail: (query: GetUserByEmailParams = {}, params: RequestParams = {}) =>
      this.request<UserWithApp, any>({
        path: `/api/users/user/byEmail`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User
     * @name GetUsersAssignedOrRevoked
     * @request GET:/api/users/assignedOrRevoked/byEmail
     */
    getUsersAssignedOrRevoked: (
      query: GetUsersAssignedOrRevokedParams = {},
      params: RequestParams = {}
    ) =>
      this.request<string[], any>({
        path: `/api/users/assignedOrRevoked/byEmail`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  userStatistics = {
    /**
     * No description
     *
     * @tags UserStatistics
     * @name SetLastLogin
     * @request POST:/api/userstatistics/lastlogin
     */
    setLastLogin: (params: RequestParams = {}) =>
      this.request<UserStatistics, any>({
        path: `/api/userstatistics/lastlogin`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  writingCertification = {
    /**
     * No description
     *
     * @tags WritingCertification
     * @name GetExaminerWritingCertifications
     * @request GET:/api/writingcertifications/examiner/{examinerId}
     */
    getExaminerWritingCertifications: (
      { examinerId, ...query }: GetExaminerWritingCertificationsParams,
      params: RequestParams = {}
    ) =>
      this.request<PagedResultOfWritingCertificationListItem, any>({
        path: `/api/writingcertifications/examiner/${examinerId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WritingCertification
     * @name Delete
     * @request DELETE:/api/writingcertifications/delete/{certificationId}/examiner/{examinerId}
     */
    delete: ({ certificationId, examinerId }: DeleteParams14, params: RequestParams = {}) =>
      this.request<Blob, any>({
        path: `/api/writingcertifications/delete/${certificationId}/examiner/${examinerId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WritingCertification
     * @name CanBeDeleted
     * @request GET:/api/writingcertifications/checkIfCertificationIsDeletable/{certificationId}
     */
    canBeDeleted: ({ certificationId }: CanBeDeletedParams, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/api/writingcertifications/checkIfCertificationIsDeletable/${certificationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WritingCertification
     * @name Get
     * @request GET:/api/writingcertifications/{id}
     */
    get: ({ id }: GetParams17, params: RequestParams = {}) =>
      this.request<WritingCertificationDetails, any>({
        path: `/api/writingcertifications/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WritingCertification
     * @name GetNextCertificationsDate
     * @request GET:/api/writingcertifications/nextcertificationdate/{examinerId}
     */
    getNextCertificationsDate: (
      { examinerId }: GetNextCertificationsDateParams2,
      params: RequestParams = {}
    ) =>
      this.request<string, any>({
        path: `/api/writingcertifications/nextcertificationdate/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WritingCertification
     * @name DoCalculation
     * @request POST:/api/writingcertifications/calculate
     */
    doCalculation: (data: WritingCertificationCalculation, params: RequestParams = {}) =>
      this.request<WritingCertificationCalculationResult, any>({
        path: `/api/writingcertifications/calculate`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WritingCertification
     * @name SaveCertification
     * @request POST:/api/writingcertifications/save
     */
    saveCertification: (data: WritingCertificationCalculationDetails, params: RequestParams = {}) =>
      this.request<WritingCertification, any>({
        path: `/api/writingcertifications/save`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WritingCertification
     * @name IsNumberOfAttemptsExceeded
     * @request GET:/api/writingcertifications/examiner/{examinerId}/isNumberOfAttemptsExceeded/{setId}
     */
    isNumberOfAttemptsExceeded: (
      { examinerId, setId }: IsNumberOfAttemptsExceededParams2,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/writingcertifications/examiner/${examinerId}/isNumberOfAttemptsExceeded/${setId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WritingCertification
     * @name IsGapBetweenAttemptsExceeded
     * @request GET:/api/writingcertifications/examiner/{examinerId}/isGapBetweenAttemptsExceeded/{setId}
     */
    isGapBetweenAttemptsExceeded: (
      { examinerId, setId, ...query }: IsGapBetweenAttemptsExceededParams2,
      params: RequestParams = {}
    ) =>
      this.request<boolean, any>({
        path: `/api/writingcertifications/examiner/${examinerId}/isGapBetweenAttemptsExceeded/${setId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags WritingCertification
     * @name GetLastPassedCertificationBasicData
     * @request GET:/api/writingcertifications/examiner/{examinerId}/lastPassedCertificationDate
     */
    getLastPassedCertificationBasicData: (
      { examinerId }: GetLastPassedCertificationBasicDataParams4,
      params: RequestParams = {}
    ) =>
      this.request<CertificationBasicDataOfLong, any>({
        path: `/api/writingcertifications/examiner/${examinerId}/lastPassedCertificationDate`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  writingCertificationRate = {
    /**
     * No description
     *
     * @tags WritingCertificationRate
     * @name GetWritingCertificationRates
     * @request GET:/api/WritingCertificationRates/{certificationId}
     */
    getWritingCertificationRates: (
      { certificationId }: GetWritingCertificationRatesParams,
      params: RequestParams = {}
    ) =>
      this.request<WritingCertificationRate[], any>({
        path: `/api/WritingCertificationRates/${certificationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  writingCertificationSet = {
    /**
     * No description
     *
     * @tags WritingCertificationSet
     * @name GetExaminerWritingCertificationsSets
     * @request GET:/api/WritingCertificationSets/availableForExaminer/{examinerId}
     */
    getExaminerWritingCertificationsSets: (
      { examinerId }: GetExaminerWritingCertificationsSetsParams,
      params: RequestParams = {}
    ) =>
      this.request<AvailableWritingCertificationSet[], any>({
        path: `/api/WritingCertificationSets/availableForExaminer/${examinerId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
}
